import React, { Component } from 'react';
import BurgerMenu from 'react-burger-menu';
import Tools from '../tools';
import MenuWrap from './menu-wrap';
import Jamulus from '../tools/jamulus';
import Login from '../login';
import Explore from '../explore';
import _, { isEqual } from 'lodash';
import { sendData } from '../../webjam/websocket';

import {
    PARTICIPANT_ROLE,
    getLocalParticipant,
    getRemoteParticipants,
    isLocalParticipantModerator,
    getParticipantCount
} from '../../base/participants';

// css for layout file
import "../main.css";
import './layout.css';
import "./custom.css";
import "./jitsi-custom2.css";
import "./jitsi-custom.css";
import { connect } from '../../base/redux';
import { i18next, translate } from '../../base/i18n';
import { displayConsole, showAppToast } from '../../webjam/helper';
import Downloader from "../custom/toolbar/FileDownloader"
import {
    getQueryString,
    InvitedUserConfirmFlag,
    isSocialMobileApp,
    SaveLog,
    isMobileBrowserC,
    DeviceInfoStatus,
    isGhostUser,
    prejoinDeviceCalculateFlag
} from '../../customise/Utils';

import {
    setData,
    setRoomorIpAddress,
    setBufferLoader,
    setAudioGhost,
    setUsersData,
    setGhostVoiceSync,
    setUserIsLogin,
    setUserLoginData,
    hideApiLoader,
    showApiLoader,
    setIsClaimClicked,
    showToastPopup,
    setAudioGhostConnect,
    setWaitingScreen,
    setChatRecordingFiles,
    setThirdPartyHostTabData,
    clickAutoMakeHost,
    setHostTabDataMain,
    setHostTabData,
    setHostInitWait,
    setAvatarPop,
    setLogoutType,
    setWaitingScreenStatus
} from '../redux/tool-webjam/actions';

import { setTileView } from '../../video-layout';
import { updateSettings } from '../../base/settings';

import {
    FEATURE_CUSTOM_PAYMENT,
    FEATURE_CUSTOM_REDUX,
    FEATURE_CUSTOM_REDUX_V2,
    FEATURE_CUSTOM_REDUX_V3,
    prejoinDetectDeviceEmitter,
    tourGuideActions,
    tourGuideVisibilityActions
} from "../constant"

import {
    hideLobbyScreen,
    setLobbyModeEnabled,
    knockingParticipantLeft,
    openLobbyScreen,
    participantIsKnockingOrUpdated,
    startKnocking,
    setPasswordJoinFailed
} from '../../lobby/actions';

import { disconnect } from '../../base/connection';


// socket setup
import Config from '../config';
const { socket_endpoint } = Config;
import { cloneSocket, socketEmit, socketOn } from "../../../../socket";
let socket;

const publicIP = require('public-ip');

import guitartuner from '../img/guitartuner.png';
import chordchart from '../img/chordchart.png';
import metronomeicon from '../img/metronome.png';
import scalegenerator from '../img/scalegenerator.png';
import whiteboard from '../img/whiteboard.png';
import piano from "../img/piano.png";
import drum from "../img/drum.png";
import drumset from "../img/drum-set.png";

import { maybeRedirectToWelcomePage } from '../../app/actions';
import Toast from 'react-simple-toasts';
import { data, isNumeric } from 'jquery';
import { v4 as uuidv4 } from 'uuid';

declare var interfaceConfig: Object;
import { deleteMediaFileApi, getStripeLink, deleteMyRecording, getMyRecordingsData, getWhiteboardAssets, searchMyRecordingsData, userLogout, getIpValidation, createConnectLink, getMyClaimedRoomsApi, getOtherRoomsApi, thirdPartyMakeHostApi, hostHangupNewApi, saveStemRecordingUrl, getFirewallTypeApi } from '../welcome-dashboard/Request.d';
import { messages, stripeMessage } from '../welcome-dashboard/messages';
import { _ValidateIPaddress, ifUppercase, getLJsonStorage } from '../welcome-dashboard/Utils';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME, HOST_RECEIVED_EVENTS } from '../../webjam/constant';
import { calculateTimeDiff, connectAccountFlag, CURRENT_TIMESTAMP, dispatch, getBaseConfig, getStore, MUSIC_MODE_STRING, _startConference } from '../Utils';
import { sendAnalytics } from '../../analytics';
import { setCustomTourAction, setDeviceContainerStatus, setDisableRecIcon, setEnableWebjamModal, setIsDeviceListed, setIsMyRecordingsModal, setMyRecordingsData, setOutAutoManage, setPaidRoomDetail, setPrejoinDeviceConnection, setPrejoinScreenDetail, setshowUploadModal, setStripeAccountCreated, setStripeAccountVerified, setStripeRequesting, setUsersListArray, setWhiteboardAssets } from '../redux/tool-webjam-v2/actions';
import { createCookie } from '../authorize/CommonFunction';
import { closeChat, setIsPollsTabFocused, toggleChat } from '../../chat/actions.web';
import { setChatTranslatorStatus } from '../custom/chat/reducer/actions';
import toast from 'react-simple-toasts';
import ModalDialog, { ModalFooter, ModalHeader } from '@atlaskit/modal-dialog';
import Footer from '../explore/footer';
import Button from '@atlaskit/button';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { copyText } from '../../base/util/copyText.web';
import { FacebookShareButton } from 'react-share';
import { hideNotification, NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../notifications';
import axios from 'axios';
import cross from '../img/cross.png';
import { JitsiRecordingConstants } from '../../base/lib-jitsi-meet';
import { getActiveSession } from '../../recording';
import CustomTour from '../custom/components/CustomTour';
import { Tooltip } from '@material-ui/core';
import ManageHost from '../custom/components/ManageHost';
import {
    setLocalAutoConnect,
    setParticipantThirdPartyEventListened,
    setModeratorThirdPartyEventListened,
    setIsDeviceConnecting,
    setHostEventReceived,
    setHostHangupEventReceived,
    setLocalBufferValue,
    setAlwaysShowPreJoining,
    setUserStaticDeviceId,
    setHideWebjamConnectedMessage,
    setTourGuideType,
    setTourGuideVisibility,
    setShowDeviceHelpingGuide,
    setConfirmationModalProps,
    showTutorialModal,
    setLiveStreamingStatus,
    setIsNatType,
    setHostHangupAutoConnect,
    setIsDisconnectListened,
    setPrejoinDeviceMessages,
    setPrejoinSubscriptionUI,
    setPrejoinDeviceStepRunning,
    setPrejoinDevicePingCalculate,
    setPrejoinDeviceConnectTime,
    setHitFirewallApi
} from '../redux/tool-webjam-v3/actions';
import { makeHostRoomStatus, SocketListnerInitApi } from '../custom/components/HelperComponent';
import HostHangup from '../custom/components/HostHangup';
import AddRtaJamPeopleDialog from '../custom/components/InviteForRtaJamPopup';
import MyRoomsModal, { JoinRoomConfirmation } from '../custom/components/MyRoomsModal';
import { GenericConfirmationModal } from '../custom/components/GenericConfirmationModal';
import { SETTINGS_TABS, SettingsButton, openSettingsDialog } from '../../settings';
import { handleUserLogout } from '../welcome-dashboard/helper';
import dummyPlaceholder from '../img/dummy-user.png';
import CustomTooltip from '../custom/toolbar/CustomTooltip';
import { MixerSettings } from '../custom/components/MixerSettings';
import Dialog from '../../base/ui/components/web/Dialog';
import Tutorial from '../../webjam/components/tutorial';
import { INFO_CODE } from '../custom/components/deviceInfoMessage';
import NavBars from '../welcome-dashboard/components/payment/helperComponent/NavBars';
import VideoLayout from '../../../../modules/UI/videolayout/VideoLayout';
import { allowedDomainHash, ct, currentHash, dynamicMessageLocale, getBaseConfigI, getWebRoomName, isIframe, isValidRoomName, localeCalender, socialRedirSufix, socialRoomsPage, webRoomNamePrefix } from '../constant-Utils';
import { setPrejoinPageVisibility } from '../../prejoin/actions.web';
import { setWhiteboardOpen } from '../../whiteboard/actions';
import { setOverflowMenuVisible } from '../../toolbox/actions.web';
import { getMySubscription } from '../welcome-dashboard/paymentRequest';
import { OPEN_DIALOG_FROM_SOCIAL } from '../redux/tool-webjam-v3/actionType';

document.title = getBaseConfig("title")
setTimeout(function () {
    document.title = getBaseConfig("title")
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = getBaseConfig("favicon")
    head.appendChild(link);


    if (getBaseConfig("themeFontFamily") != undefined) {
        if (getBaseConfig("themeFontFamily") != "") {
            let addFont = document.createElement("style");
            let addFontStyle = document.createTextNode("@font-face {font-family: 'Nunito Sans';src: url('/fonts/NunitoSans-Regular.eot');src: url('/fonts/NunitoSans-Regular.eot?#iefix') format('embedded-opentype'),url('/fonts/NunitoSans-Regular.woff2') format('woff2'),  url('/fonts/NunitoSans-Regular.woff') format('woff'),  url('/fonts/NunitoSans-Regular.ttf') format('truetype'),  url('/fonts/NunitoSans-Regular.svg#NunitoSans-Regular') format('svg');font-weight: normal;font-style: normal;font-display: swap;}@font-face {font-family: 'Nunito Sans';src: url('/fonts/NunitoSans-Bold.eot');src: url('/fonts/NunitoSans-Bold.eot?#iefix') format('embedded-opentype'),  url('/fonts/NunitoSans-Bold.woff2') format('woff2'),  url('/fonts/NunitoSans-Bold.woff') format('woff'),  url('/fonts/NunitoSans-Bold.ttf') format('truetype'),  url('/fonts/NunitoSans-Bold.svg#NunitoSans-Bold') format('svg');font-weight: bold;font-style: normal;font-display: swap;}@font-face {font-family: 'Nunito Sans';src: url('/fonts/NunitoSans-SemiBold.eot');src: url('/fonts/NunitoSans-SemiBold.eot?#iefix') format('embedded-opentype'),  url('/fonts/NunitoSans-SemiBold.woff2') format('woff2'),  url('/fonts/NunitoSans-SemiBold.woff') format('woff'),  url('/fonts/NunitoSans-SemiBold.ttf') format('truetype'),  url('/fonts/NunitoSans-SemiBold.svg#NunitoSans-SemiBold') format('svg');font-weight: 600;font-style: normal;font-display: swap;}body, button, input, keygen, select, textarea {font-family: '" + getBaseConfig("themeFontFamily") + "' !important;}");
            addFont.appendChild(addFontStyle);
            document.body.appendChild(addFont)
        }
    }
}, 2000)

// current user session id
let SessionId = ''

// user who opened the tool
let openByUser = '';

//USER ROOMNAME OR IPADDRESS USED TO CONNECT
let realName = CURRENT_ROOM_NAME;
let ipAddress = realName && realName.toLowerCase().replace(/%20/g, '').trim();
ipAddress = getWebRoomName(ipAddress)

console.log("My ip name ", ipAddress)

/**
 * 1). 11.11.11.11:8909 input
 * 2). 11.11.11.11_8909 input
 * 3). 11-11-11-11:7845 input
 * 4). 11-11-11-11_7845 input
 * 
 * 5). 11.11.11.11:7845 backend
 * 6). 11.11.11.11_7845 frontend
 */

let port = "";
let ip = "";
let isIp = false;

if (_ValidateIPaddress(ipAddress)) {
    let _port = "";
    let _ip = ipAddress;
    let removel = "";
    isIp = true
    if (ipAddress.includes(":")) {
        _port = ipAddress.split(":").pop()
        removel = ":" + _port;
    } else if (ipAddress.includes("_")) {
        _port = ipAddress.split("_").pop()
        removel = "_" + _port;
    }
    if (_port) {
        _ip = ipAddress.replace(removel, "");
        if (_ip.includes("-")) {
            _ip = _ip.replace(/-/g, ".");
        }
    }
    ipAddress = _ip + (_port && ":" + _port)

    let frontUrl = _ip.replace(/-/g, ".") + (_port && "_" + _port);
    if (realName != frontUrl) {
        window.location.href = frontUrl;
    }
}

if (realName && ifUppercase(realName)) {
    window.location.href = window.location.origin + "/" + ipAddress;
}

if (ipAddress.indexOf("/") != -1) {
    window.location.href = window.location.origin + "/" + ipAddress.replace(/\//g, '');
}

if (ipAddress.length) {
    // if (!isIp) {
    let willStop = isValidRoomName(ipAddress);
    if (willStop) {
        if (window.location.parent) {
            window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
        } else {
            window.location.href = window.location.origin;
        }
    }
    // }
}
class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isConfirming: false,
            isViewMyRoomsModal: false,
            isJoiningAnotherRoom: false,
            currentMenu: props.activeMenu || 'slide',
            side: props.side || 'left',
            openTool: '',
            isMenuOpen: false,
            isToolsOpen: false,
            isExploreOpen: false,
            isMyRoomList: false,
            isOtherRoomList: false,
            roomName: null,
            myRoomList: [],
            otherRoomList: [],
            myRoomListLoading: false,
            otherRoomListLoading: false,
            //FOR WHITEBOARD TOOLS
            isSubToolsOpen: false,
            isAudioToolsOpen: false,
            //-----
            isJamDailogOpen: false,
            explorePop: '',
            isLoginDialogOpen: false,
            user: {
                isLogged: false
            },
            isMixerShow: false,
            isDomiantReceived: false,
            showDeviceHelpModal: false,
            mediaDetail: '',
            whiteboardAudio: false,
            whiteboardFiles: false,
            isManualOpen: false,
            openMediaModal: false,
            allMediaType: '',
            currentPage: 1,
            claimedRoomEvent: false,
            closeUploadMsgModals: false,
            toolOpenLocal: false,
            stripeActivated: false,
            toolDetail: "",
            openRecordingsModal: false,
            recordings_start_date: '',
            recordings_end_date: '',
            selectedRoom: 'Select Room Name',
            selectedRecord: '',
            searchApi: false,
            hitApi: false,
            takeTour: false,
            stripe_menu: false,
            emptyHostTabData: true,
            autoHostData: true,
            showHangupPopup: false,
            isRedirectToRTASocialWeb: false,
            showSidebarCustomTooltip: true,
        };

    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.componentCleanup);

        const {
            dispatch,
            roomorIpAddress,
            clickedAutoMakeHost,
            conferenceJoined,
            lobbyStatus,
            iAmRecorder
        } = this.props;

        let static_device_id = getQueryString("device_id");
        dispatch(getMySubscription())
        if (static_device_id) {
            if (static_device_id.length == 6) {
                static_device_id = static_device_id.toUpperCase()
                dispatch(setUserStaticDeviceId(static_device_id))
            }
        }

        let noChangedRoomName = getBaseConfig('noChangedRoomName')
        //  const { usersData } = getStore(FEATURE_CUSTOM_REDUX)
        if (noChangedRoomName == true) {
            if (_ValidateIPaddress(ipAddress)) {
                if (ipAddress && ipAddress.indexOf("_") != -1) {
                    ipAddress = ipAddress.replace("_", ":")
                }
            }
        }

        // if (!conferenceJoined) {
        //     let localSocketId = localStorage.getItem('socketId');
        //     socket.emit('get_open_tool', {
        //         location: window.location.origin,
        //         room: CURRENT_ROOM_NAME,
        //         socketId: localSocketId,
        //     })
        // }

        dispatch(setRoomorIpAddress(ipAddress, 'layout componentDidMount'));

        this.setState({
            autoHostData: clickedAutoMakeHost,
        });

        if (window.location.href.indexOf("AUDIO_GHOST") != -1
            || window.location.href.indexOf("config.iAmRecorder") != -1
            || iAmRecorder
        ) {
            displayConsole("AUDIO_GHOST =====>", window.location.href.indexOf("AUDIO_GHOST"));
            dispatch(setAudioGhost(true));
            //dispatch(setAudioMuted(true));
            dispatch(hideLobbyScreen(true));
            dispatch(setLobbyModeEnabled(false));
        }

        if (getBaseConfig("customTutorial") == true) {
            let _This = this;
            const _isGuestUser = getLJsonStorage("auth", "guest_id");
            // if user have guest account, then hide guide tour
            if (!_isGuestUser) {
                setTimeout(function () {
                    let showTourGuide = localStorage.getItem("showTourGuide")
                    if (showTourGuide || isGhostUser()) {
                        dispatch(setCustomTourAction(false))
                        _This.setState({
                            takeTour: false,
                        });
                    } else {
                        dispatch(setCustomTourAction(true))
                        _This.setState({
                            takeTour: true,
                        });
                    }
                }, 8000)
            }
        }

        socket = cloneSocket();
        socket.on("id", (id) => {
            SessionId = id;
            openByUser = id;
            //action to set room name or ipAddress used to connect present room
            let noChangedRoomName = getBaseConfig('noChangedRoomName')
            // if (noChangedRoomName == true) {
            //     if (ipAddress && ipAddress.indexOf("_") != -1) {
            //         ipAddress = ipAddress.replace("_", ":")
            //     }
            // }
            // dispatch(setRoomorIpAddress(ipAddress, 'layout componentDidMount cloneSocket'));
        });

        socket.on("openTools_return", (data) => {
            //displayConsole("socker retuned ",data)
            const { usersData, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)

            const { location, openTool, SessionId, mediaDetail } = data;
            const { getLocalParticipant } = this.props;
            const localParticipantId = getLocalParticipant?.id;

            if (location === CURRENT_ROOM_LOCATION) {
                if (usersData == undefined && data?.openTool == "box-metronome") {
                } else {
                    openByUser = SessionId;
                    if (conferenceJoined) {
                        this.setState({
                            openTool,
                            mediaDetail,
                            isManualOpen: false,
                            toolOpenLocal: false
                        });
                        if (data?.openTool == 'simple-whiteboard' && localParticipantId != data.sessionId) {
                            dispatch(setWhiteboardOpen(true));
                            dispatch(setOverflowMenuVisible(false));
                        }
                    }
                }
            }
        });

        socket.on("closetool_return", (data) => {
            //alert("3"+this.state.openTool+"_"+openByUser+"_"+SessionId)
            if (this.state.openTool !== "box-metronome") {

                localStorage.removeItem('isPitchActive');
                const { location } = data;
                openByUser = SessionId;

                if (location === CURRENT_ROOM_LOCATION && this.state.openTool != "metronome") {
                    this.setState({
                        openTool: '',
                        toolOpenLocal: false,
                        toolDetail: ''
                    });
                }

                if (location === CURRENT_ROOM_LOCATION && data?.openTool == 'simple-whiteboard') {
                    dispatch(setWhiteboardOpen(false));
                    dispatch(setOverflowMenuVisible(false));
                }
            }

            if (this.state.openTool === "box-metronome") {
                if (data.toolName == "box-metronome") {
                    this.setState({
                        openTool: '',
                        toolOpenLocal: false,
                        toolDetail: ''
                    });
                }
            }
        });

        // return for dominant speakers
        socket.on("domiantUrl_return", (data) => {

            // if (!this.state.isDomiantReceived) {
            //     this.setState({
            //         isDomiantReceived: true
            //     })

            const { roomLocation, dominant } = data;
            const { userLoginData, getLocalParticipant, dispatch, tokenDecodedData, conferenceJoined } = this.props;
            console.log("domiantUrl_return 1 =>", data)
            if (data.hasOwnProperty("mode") && roomLocation === CURRENT_ROOM_LOCATION) {
                console.log("domiantUrl_return 2 =>", conferenceJoined)
                if (conferenceJoined == true) {
                    console.log("domiantUrl_return 3 =>", getLocalParticipant.id, data?.uid)
                    // To bypass with/without device popup and hide lobby notification when admin/teacher/moderator change the music mode
                    dispatch(setAudioGhostConnect(true));
                    setTimeout(() => {
                        dispatch(setAudioGhostConnect(false));
                    }, 30000)

                    // dominant speaker
                    if (getLocalParticipant.id != data?.uid) {
                        console.log("domiantUrl_return 4 =>", data.mode)
                        sessionStorage.setItem("music_tm_" + CURRENT_ROOM_NAME, Math.round(new Date().getTime() / 1000))

                        if (data.mode == true) {
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("messages.musicModeOn", "messages") }));
                        } else if (data.mode == false) {
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("messages.musicModeOff", "messages") }));
                        }

                        setTimeout(function () {
                            dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                        }, messages.musicModeMessageTime);

                        console.log("domiantUrl_return 5 =>", userLoginData.room, data?.isClaimed, tokenDecodedData, userLoginData?.user?.is_invited)
                        if (userLoginData.room || data?.isClaimed == true || (tokenDecodedData != undefined && tokenDecodedData)) {
                            console.log("domiantUrl_return 6 =>")
                            let musicFlagStorage = JSON.stringify({
                                roomLocation,
                                time: Math.round(new Date().getTime() / 1000),
                                location: window.location.origin,
                                roomName: CURRENT_ROOM_NAME,
                                tokenDecodedData,
                                mode: data.mode
                            })
                            localStorage.removeItem("musicModeUser");
                            localStorage.setItem("musicModeUser", musicFlagStorage);

                            document.cookie = "room=";
                            document.cookie = "loc=";

                            createCookie("room", tokenDecodedData.room)
                            createCookie("loc", window.location.origin)


                            setTimeout(function () {
                                if (!isSocialMobileApp() && getBaseConfig("allowIframeOpen") == true) {
                                    let socialLocalFlag = {
                                        local: {
                                            "musicModeUser": musicFlagStorage,
                                        },
                                        session: {
                                            ["music_tm_" + CURRENT_ROOM_NAME]: Math.round(new Date().getTime() / 1000)
                                        }
                                    }
                                    window.parent.location.href = getBaseConfig("socialBaseUrl") + "/" + socialRoomsPage + "?musicModeStore=" + btoa(JSON.stringify(socialLocalFlag));
                                } else {
                                    window.location.href = window.location.origin;
                                }
                            }, messages.musicModeReload);
                        } else {
                            // room is not claimed
                            console.log("domiantUrl_return 7 =>", data.mode)
                            let reloadUrl = '#config.disableAP=false';
                            if (data.mode == true) {
                                console.log("domiantUrl_return 8 =>")
                                reloadUrl = "#config.disableAP=true&config.disableHPF=false&config.disableNS=false&config.disableAGC=false&config.disableAEC=false&config.audioQuality.stereo=true&config.audioQuality.opusMaxAverageBitrate=510000&config.p2p.enabled=false";
                            }

                            setTimeout(function () {
                                console.log("domiantUrl_return 9 =>", reloadUrl)
                                if (reloadUrl) {
                                    window.location.href = CURRENT_ROOM_LOCATION + reloadUrl
                                }
                            }, messages.musicModeReload);
                        }
                    }
                }
            } else {
                // Moderator/admin joined after music mode ON/OFF
                console.log("domiantUrl_return 10 =>", localStorage.getItem("musicModeUser"))

                if (localStorage.getItem("musicModeUser")) {
                    try {
                        let olData = localStorage.getItem("musicModeUser");
                        let jsonD = JSON.parse(olData);
                        console.log("domiantUrl_return 11 =>", jsonD.hasOwnProperty("roomLocation"))
                        if (jsonD.hasOwnProperty("roomLocation")) {
                            console.log("domiantUrl_return 12 =>", jsonD.location, data.location)
                            if (jsonD.location == data.location) {
                                console.log("domiantUrl_return 13 =>", jsonD.mode)
                                // this.setState({
                                //     isMusicModeReceived : true
                                // })

                                // Hide lobby notification when admin/teacher/moderator change the music mode
                                if (jsonD.mode == true) {
                                    if (data.moderatorStatus != "enable") {
                                        return false
                                    }
                                } else if (jsonD.mode == false) {
                                    if (data.moderatorStatus != "disable") {
                                        return false
                                    }
                                }

                                // need to add a new check to check if this event is already received just a few sec ago
                                let existingSession = sessionStorage.getItem("claimedUserD");
                                if (existingSession) {
                                    try {
                                        existingSession = JSON.parse(existingSession);
                                        if (existingSession.hasOwnProperty("time")) {
                                            let timeDiff = calculateTimeDiff(existingSession.time, 10);
                                            console.log("time diff ", timeDiff)
                                            if (timeDiff) {
                                                return false;
                                            }
                                        }
                                    } catch (e) {
                                        console.log("music mode exiting session error ", e)
                                    }
                                }

                                dispatch(setAudioGhostConnect(true));

                                setTimeout(() => {
                                    dispatch(setAudioGhostConnect(false));
                                }, 30000)

                                console.log("domiantUrl_return 14 =>", data.hasOwnProperty("moderatorStatus"))
                                if (data.hasOwnProperty("moderatorStatus")) {
                                    console.log("domiantUrl_return 15 =>")
                                    let roomUrl = roomLocation;
                                    let _roomName = data.roomName;
                                    let modeHash = ""
                                    if (data.moderatorStatus == "enable") {
                                        roomUrl += MUSIC_MODE_STRING;
                                        _roomName += MUSIC_MODE_STRING
                                        modeHash = MUSIC_MODE_STRING
                                    }

                                    sessionStorage.removeItem("claimedUserD")

                                    let sessionStore = JSON.stringify({
                                        roomLocation,
                                        time: Math.round(new Date().getTime() / 1000),
                                        // roomName: data.roomName
                                        roomName: data.roomName,
                                        tokenDecodedData
                                    })
                                    sessionStorage.setItem("claimedUserD", sessionStore)

                                    localStorage.removeItem("musicModeUser");
                                    localStorage.setItem("musicModeUserNotify", true)
                                    document.cookie = "room=";
                                    document.cookie = "loc=";
                                    console.log("domiantUrl_return 16 =>", getBaseConfig("allowIframeOpen"))
                                    if (!isSocialMobileApp() && getBaseConfig("allowIframeOpen") == true) {

                                        let socialLocalFlag = {
                                            local: {
                                                "musicModeUserNotify": true,
                                            },
                                            session: {
                                                "claimedUserD": sessionStore
                                            },
                                            hash: modeHash
                                        }
                                        let token = btoa(JSON.stringify(socialLocalFlag));
                                        window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + data.roomName + "?musicModeStore=" + token
                                    } else {
                                        window.location.href = roomUrl;
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.log("musicModeUser error =>", e)

                    }
                }
            }
            // }
        });


        let createifrm = document.createElement("iframe");
        // createifrm.src = Constant.App.PianoUrl;
        createifrm.src = getBaseConfig("pianoUrl");
        createifrm.style.display = "none";
        document.body.appendChild(createifrm)

        socketOn("media-files-updated", data => {
            const { authOrganization, roomorIpAddress } = this.props
            const { currentPage } = this.state;
            if (data.room_name == roomorIpAddress) {
                toast(ct("messages.fileUploadSuccess", "messages"), Constant.App.ToastTime.LongCloseTime)
                dispatch(getWhiteboardAssets("?organization_id=" + authOrganization._id + "&room_name=" + roomorIpAddress + "&page_num=" + currentPage))
            }
        })

        socketOn("media-files-deleted", data => {
            const { authOrganization, roomorIpAddress } = this.props
            const { currentPage } = this.state;
            if (data.room_name == roomorIpAddress) {
                toast(ct("messages.fileDeleteSuccess", "messages"), Constant.App.ToastTime.LongCloseTime)
                dispatch(getWhiteboardAssets("?organization_id=" + authOrganization._id + "&room_name=" + roomorIpAddress + "&page_num=" + currentPage))
            }
        })

        socketOn("stripe_connect", data => {
            let {
                stripeSessionId
            } = this.state;

            if (stripeSessionId != undefined || this.props?.windowRef?.uid !== null) {
                if (stripeSessionId?.uid === data.session_id || this.props?.windowRef?.uid === data.session_id) {
                    dispatch(setStripeAccountCreated(false))
                    // dispatch(setStripeAccountVerified("failed"))

                    dispatch(showApiLoader())

                    setTimeout(function () {
                        if (stripeSessionId?.win) {
                            stripeSessionId.win.close();
                        }

                        if (this.props?.windowRef?.win) {
                            this.props?.windowRef?.win?.close();
                        }
                    }, 2000)

                    setTimeout(function () {
                        dispatch(hideApiLoader())
                    }, 500)

                    dispatch(setStripeAccountCreated(true))

                    // let status = "";
                    // if (data?.isPending == true) {
                    //     status = "pending"
                    // } else if (data?.isFailed == true && data?.isPending == false) {
                    //     status = "failed"
                    // } else if (data.account_verify == true && data?.isFailed == false) {
                    //     status = "approved"
                    //     this.setState({
                    //         stripeActivated: true
                    //     })
                    // } else if (data.account_verify == false && data?.isFailed == true) {
                    //     status = "failed"
                    // }

                    let status = "";
                    if (data?.accountStatus == connectAccountFlag.FAILED) {
                        status = connectAccountFlag.FAILED
                    } else if (data?.accountStatus == connectAccountFlag.ENABLED) {
                        status = connectAccountFlag.ENABLED
                    } else if (data?.accountStatus == connectAccountFlag.APPROVED) {
                        status = connectAccountFlag.APPROVED
                        this.setState({
                            stripeActivated: true
                        })
                    }

                    let openModal = "";
                    var { userLoginData } = this.props;
                    if (status == connectAccountFlag.APPROVED) {
                        if (!userLoginData?.room) {
                            openModal = "claim-room";
                        } else {
                            if (userLoginData?.room) {
                                if (userLoginData?.isAdmin) {
                                    openModal = "settings";
                                }
                            }
                        }
                    }

                    if (data?.isPending) {
                        status = connectAccountFlag.PENDING
                    }

                    dispatch(setStripeAccountVerified(status))

                    try {
                        dispatch(setUserLoginData({
                            ...userLoginData,
                            user: {
                                ...userLoginData.user,
                                stripe_account_id: true,
                                connectVerified: status
                            }
                        }, 2))
                    } catch (e) {
                        console.log("setUserLoginData error =>", e)
                    }

                    // if (localStorage.getItem("auth")) {
                    //     try {
                    //         let auth = localStorage.getItem("auth");
                    //         auth = JSON.parse(auth);
                    //         auth = Object.assign(auth, {
                    //             stripe_account_id: "true"
                    //         });

                    //         auth = Object.assign(auth, {
                    //             connectVerified: status
                    //         });
                    //         localStorage.setItem("auth", JSON.stringify(auth))
                    //     } catch (e) {
                    //     }
                    // }

                    if (openModal != "" && stripeSessionId?.uid) {
                        if (!_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                            this.setState({
                                explorePop: openModal,
                                isMenuOpen: false
                            })
                        }
                    }

                    // setTimeout(function () {
                    //     if (data?.isPending == undefined) {
                    //         dispatch(setStripeRequesting(false))
                    //     }
                    // }, 5000)
                }
            }
        })
        socketOn("payment_status", data => {

            const { userLoginData } = this.props;
            let {
                stripeSessionId
            } = this.state;
            if (userLoginData?.room) {
                if (data.checkout_session == stripeSessionId?.checkout_session && data.room_id == userLoginData?.room?.id) {
                    if (data.status == "succeeded") {
                        stripeSessionId?.payWin.close()
                        dispatch(setUserLoginData({
                            ...userLoginData,
                            isPaid: true
                        }, 3))
                        setTimeout(function () {
                            dispatch(setPaidRoomDetail({
                                passwordProtected: userLoginData.room.isPasswordProtected,
                                isRoomPaid: userLoginData?.room?.paid || false,
                                time: Math.round(new Date().getTime() / 1000),
                                isUserMadePayment: true
                            }))
                        }, 1000)
                    }
                }
            }
        })

        socketOn("new_room_claimed", data => {
            let { roomorIpAddress } = this.props;
            if (data.groupName == roomorIpAddress) {
                this.setState({ claimedRoomEvent: true });
            }
        })


        let hasConnect = getLJsonStorage("auth", "stripe_account_id");
        let hasVerified = getLJsonStorage("auth", "connectVerified");

        // if (hasConnect && hasVerified === "approved") {
        //     this.setState({
        //         stripeActivated: true
        //     })
        // }

        if (this.props.userLoginData?.user?.stripe_account_id && this.props.userLoginData?.user?.connectVerified == connectAccountFlag.APPROVED) {
            this.setState({
                stripeActivated: true
            })
        }

        socketOn("get_open_tool_return", data => {
            let { lobbyStatus } = this.props
            let localSocketId = localStorage.getItem('socketId');
            let showPreJoining = getBaseConfig('showPreJoining');
            if (showPreJoining) {
                if (data.hasOwnProperty("socketId")) {
                    if (data.room == CURRENT_ROOM_NAME && data.location == window.location.origin && data.socketId != localSocketId) {
                        socket.emit('set_open_tool', {
                            location: window.location.origin,
                            room: CURRENT_ROOM_NAME,
                            socketId: localSocketId,
                            lobbyStatus: lobbyStatus
                        })
                    }
                }
            } else {
                const { getLocalParticipant, roomorIpAddress, toolsObject, clickedAutoMakeHost } = this.props
                const { openTool } = this.state
                const { usersListArray } = getStore(FEATURE_CUSTOM_REDUX_V2);
                if ((data.room == roomorIpAddress || data.room == CURRENT_ROOM_NAME) && data.location == window.location.origin && data.jitsiId != getLocalParticipant.id) {
                    socket.emit('set_open_tool', {
                        location: window.location.origin,
                        room: CURRENT_ROOM_NAME,
                        jitsiId: getLocalParticipant.id,
                        tool: openTool,
                        param: this.state.toolDetail,
                        deviceListArray: usersListArray,
                        // amh checkbox
                        autoManageCheckboxClick: clickedAutoMakeHost,
                    })
                }
            }
        })

        socketOn("set_open_tool_return", data => {
            let localSocketId = localStorage.getItem('socketId');
            let showPreJoining = getBaseConfig('showPreJoining');
            if (showPreJoining) {
                if (data.hasOwnProperty("socketId")) {
                    if (data.room == CURRENT_ROOM_NAME && data.location == window.location.origin && data.socketId != localSocketId) {
                        if (data.lobbyStatus) {
                            dispatch(setAlwaysShowPreJoining(false))
                        }
                    }
                }
            } else {
                const { getLocalParticipant, roomorIpAddress, participantCount } = this.props
                if ((data.room == roomorIpAddress || data.room == CURRENT_ROOM_NAME) && data.location == window.location.origin && data.jitsiId != getLocalParticipant.id) {
                    // amh checkbox
                    if (participantCount > 1) {
                        let autoManageCheckboxClick = data.autoManageCheckboxClick
                        dispatch(clickAutoMakeHost({ clickedAutoMakeHost: autoManageCheckboxClick }, 'set_open_tool_return'));
                    }
                    // if (autoManageCheckboxClick == undefined || autoManageCheckboxClick == null) {
                    //     autoManageCheckboxClick = true;
                    // }
                    // dispatch(setOutAutoManage(autoManageCheckboxClick))

                    dispatch(setUsersListArray(data.deviceListArray))
                    // if (data.tool == 'voice-chord') {
                    let obj = {
                        openTool: data.tool,
                        isMenuOpen: false,
                        mediaDetail: "",
                        isManualOpen: false,
                        toolDetail: ""
                    }

                    if (obj.openTool == "piano") {
                        obj.isManualOpen = true
                    } else {
                        obj.isManualOpen = false
                    }
                    let allowedToolSync = getBaseConfig("allowedToolSync");
                    if (allowedToolSync.includes(data.tool)) {
                        if (obj.openTool == "voice-chord") {
                            obj.toolDetail = {
                                isSocket: true,
                                ...data.param
                            };
                        }
                        if (obj.openTool == "guitar-scale") {
                            obj.toolDetail = {
                                isSocket: true,
                                ...data.param.params,
                                ...data.param.html
                            };
                        }
                        this.setState(obj);
                    }
                }
            }
        })

        socketOn("recording_started", data => {
            const { authOrganization, roomorIpAddress, userLoginData, duetUserId } = this.props
            if (data.organization_id == authOrganization._id && (data.room == roomorIpAddress || data.room == CURRENT_ROOM_NAME)) {
                let startedBy = "";
                if (data.recordingInitiator != undefined) {
                    startedBy = data.recordingInitiator
                }

                dispatch(setDisableRecIcon(true, startedBy));
                if (data.status) {


                    if (data.hasOwnProperty("user_id")) {
                        let hasUserId = "";
                        if (userLoginData) {
                            if (userLoginData?.user?.id) {
                                hasUserId = userLoginData.user.id
                            }
                        }
                        if (!hasUserId && duetUserId) {
                            if (duetUserId?.user_id) {
                                hasUserId = duetUserId.user_id;
                            }
                        }

                        if (!hasUserId || (hasUserId && hasUserId != data.user_id)) { // show init notification to another user
                            dispatch(showNotification({
                                descriptionKey: ct("Translate.messages.initializeRecording"),
                                titleKey: ct("Translate.messages.initializeRecordingHeading"),
                                customActionNameKey: ["recording.init"],
                                uid: "recording.init"
                            }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                        }
                    }
                }
            }
        })

        socketOn("recording_stopped_return", data => {
            const { authOrganization, roomorIpAddress } = this.props
            if (data.organization_id == authOrganization._id && (data.room == roomorIpAddress || data.room == CURRENT_ROOM_NAME)) {
                dispatch(hideNotification("recording.init"))
                dispatch(setDisableRecIcon(false));
            }
        })

        socketOn("streaming_status_return", data => {
            const { authOrganization, roomorIpAddress, userLoginData, duetUserId, getLocalParticipant } = this.props;
            if (data.organization_id == authOrganization._id && (data.room == roomorIpAddress || data.room == CURRENT_ROOM_NAME)) {
                let startedBy = "";
                if (data.jitsiId != undefined) {
                    startedBy = data.jitsiId
                }
                dispatch(setLiveStreamingStatus(data.status, startedBy))
                if (data.jitsiId != getLocalParticipant.id) {
                    if (data.status == true) { // show init notification to another user
                        dispatch(showNotification({
                            descriptionKey: 'liveStreaming.pending',
                            titleKey: 'dialog.liveStreaming',
                            customActionNameKey: ["liveStreaming.prepare"],
                            uid: "liveStreaming.prepare"
                        }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                    } else {
                        dispatch(hideNotification("liveStreaming.prepare"))
                    }
                }
            }
        })

        // catch any error at run time is device has any error
        socketOn("box-device-status", data => {

            const { usersData, uniqueId, publicIp, conferenceJoined, availableUserIp } = this.props;

            if (data.device_ip == publicIp || availableUserIp.indexOf(data.device_ip) != -1) {
                if (data.device_id == uniqueId && usersData && data.info_code.length) {
                    if (data.info_code.indexOf(INFO_CODE.NO_INTER) != -1) {
                        // hold the interface error for a while, don't show any other error
                        dispatch(setUsersData(null));
                        dispatch(setBoxDeviceErrorInfo({
                            error: data.info_code,
                            type: DeviceInfoStatus.WAITING
                        }))
                        let _this = this;
                        setTimeout(() => {
                            dispatch(setBoxDeviceErrorInfo({
                                error: [],
                                type: DeviceInfoStatus.DEFAULT
                            }))
                            this.setState({ explorePop: 'webjam', isMenuOpen: false });
                        }, 30000)

                        dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.interfaceRemoved") }));
                        setTimeout(() => {
                            dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                        }, 30000)

                    }
                }
            }

            if (usersData && usersData != null) {
                if (uniqueId == data.device_id && data.device_ip == publicIp && data.info_code != "") {
                    let showData = data.message;
                    if (data.type == "notify") {
                        // show error notification
                    } else if (data.type == "detail") {
                        // data.reasonDetail
                        // show device error to user at run time
                    }
                }
            } else if (data.device_ip == publicIp || availableUserIp.indexOf(data.device_ip) != -1) { // also add check of user id as well

                // trigger the event to restart the prejoin screen functionality to check the device connectivity

                // dispatch(showNotification({
                //     titleKey: 'Realtime audio device status',
                //     descriptionKey: data.message?.join(" ")
                // }, NOTIFICATION_TIMEOUT_TYPE.STICKY));

                if (!conferenceJoined) {
                    if (data.info_code.length) {
                        dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.SOC_RECEIVED_ERROR))
                        // show error only
                    } else {
                        // don't show any error will wait for next event that is devices /device-list
                        dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.SOC_RECEIVED))
                        // dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.SOC_RECEIVED, data.device_id))

                    }
                }
            }
        })
        socketOn("third_party_moderator_connected_return", data => {
            var { local } = getStore("features/base/participants");
            const { thirdPartyModEvent } = getStore(FEATURE_CUSTOM_REDUX_V2);
            let getStoreV3 = getStore(FEATURE_CUSTOM_REDUX_V3);

            if (!getStoreV3.localThirdPartyEventListened || !getStoreV3.isModeratorThirdPartyListen) {
                try {
                    let initRoom = data.room;
                    let propRoom = thirdPartyModEvent.newRoomName;
                    if (initRoom.indexOf(":") != -1) {
                        initRoom = initRoom.replace(":", "_")
                    }
                    if (propRoom.indexOf(":") != -1) {
                        propRoom = propRoom.replace(":", "_")
                    }
                    if (data.location == window.location.origin && initRoom == propRoom && data.jitsiId !== local.id) {
                        // if (localStorage.getItem('thirdPartyMakeHostConnect') == 'true') {
                        let savedUniqueid = localStorage.getItem("uniqueID");
                        let newRoomName = data.room
                        let noChangedRoomName = getBaseConfig('noChangedRoomName')

                        if (noChangedRoomName == true) {
                            if (_ValidateIPaddress(ipAddress)) {
                                if (newRoomName && newRoomName.indexOf("_") != -1) {
                                    newRoomName = newRoomName.replace("_", ":")
                                }
                            }
                        } else {
                            if (newRoomName.indexOf(":") != -1) {
                                newRoomName = newRoomName.replace(":", "_")
                            }
                        }
                        // if (localStorage.getItem('thirdPartyMakeHostConnect') == 'true') {
                        //     let roomorIpAddressNew = roomorIpAddress
                        //     if (noChangedRoomName == true) {
                        //         if (roomorIpAddressNew && roomorIpAddressNew.indexOf("_") != -1) {
                        //             roomorIpAddressNew = roomorIpAddressNew.replace("_", ":")
                        //         }
                        //     }

                        //     let hostTimer = setTimeout(() => {
                        //         dispatch(hideApiLoader("make-host-disconnect"));
                        //         const message = {
                        //             action: {
                        //                 uniqueID: savedUniqueid,
                        //                 ipAddress: roomorIpAddressNew,
                        //                 protocolId: localStorage.getItem("timeStamp")
                        //             },
                        //             content: 'unique_check',
                        //             isBroadcast: true,
                        //             sender: 'mobile',
                        //             scope: "socket listen"
                        //         };
                        //         sendData(message);
                        //     }, 15000);
                        //     setTimeout(() => {
                        //         if (hostTimer) {
                        //             clearTimeout(hostTimer);
                        //             //hideLoader("make-host-disconnect");	
                        //             dispatch(hideApiLoader("make-host-disconnect"));
                        //         }
                        //     }, 20000);
                        // }

                        if (newRoomName != '') {
                            setTimeout(() => {
                                // localStorage.setItem("thirdPartyEventListened", "true")
                                dispatch(setParticipantThirdPartyEventListened(true))
                                localStorage.setItem("windowRedirect", 'true');
                                dispatch(setData({
                                    uniqueId: savedUniqueid,
                                    room: newRoomName
                                }));
                                let noChangedRoomName = getBaseConfig('noChangedRoomName')

                                if (noChangedRoomName == true) {
                                    if (_ValidateIPaddress(newRoomName)) {
                                        if (newRoomName && newRoomName.indexOf("_") != -1) {
                                            newRoomName = newRoomName.replace("_", ":")
                                        }
                                    }
                                    dispatch(setRoomorIpAddress(newRoomName, 'third_party_moderator_connected_return'));
                                } else {
                                    window.location.replace(`/${newRoomName}`);
                                }
                            }, 3000);
                        }
                        // }
                    }
                } catch (e) {
                    console.log("third_party_moderator_connected_return error =>", e)
                }
            }
        })

        socketOn("visible_box_room", roomsData => {
            try {
                // if (roomsData.visibleRoom == CURRENT_ROOM_NAME) {
                let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
                if (roomsData.visibleRoom == CURRENT_ROOM_NAME && store_v1.conferenceJoined) {
                    const { roomorIpAddress, participantCount } = this.props
                    if (roomsData.room != roomorIpAddress && roomorIpAddress != undefined) {
                        const { usersData, protocolId } = this.props
                        if (usersData?.uniqueId == localStorage.getItem("uniqueID")) {
                            const data = {
                                action: {
                                    uniqueID: usersData.uniqueId,
                                    ipAddress: roomorIpAddress,
                                    protocolId,
                                },
                                content: 'unpair-device',
                                isBroadcast: true,
                                sender: 'mobile'
                            }

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: data.content,
                                requestData: data,
                                responseData: '',
                                userId: '',
                                boxId: data.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            sendData(data);
                            dispatch(setParticipantThirdPartyEventListened(true))

                        } else {
                            dispatch(setRoomorIpAddress(roomsData.room, 'visible_box_room'));
                        }
                    }
                    if (roomsData.hasOwnProperty("autoHost")) {
                        if (roomsData?.autoHost == null) {
                            let storeV1 = getStore(FEATURE_CUSTOM_REDUX);
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: storeV1.clickedAutoMakeHost }, 'visible_box_room null'));
                        } else {
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: roomsData?.autoHost }, 'visible_box_room'));
                        }
                    }
                }
            } catch (e) {
                console.log("visible_box_room error =>", e)
            }
        })

        socketOn("host_hangup", data => {
            console.log("host hangup host_hangup 1 =>", data)
            try {
                const { roomorIpAddress, usersData, isDisconnectListened } = this.props
                console.log("host hangup host_hangup 2 =>", window.location.origin, roomorIpAddress, usersData, usersData?.isHost)
                if (data.location == window.location.origin && data.room == roomorIpAddress && usersData && !usersData.isHost) {
                    let hangupAction = 0;
                    if (data.actionType) {
                        hangupAction = data.actionType;
                    }
                    console.log("host hangup host_hangup 3 =>", hangupAction)
                    dispatch(setHostHangupEventReceived(true, hangupAction))
                    dispatch(setDeviceContainerStatus("hostHangupEventReceived", 'host_hangup'))
                    this.setState({
                        explorePop: '',
                        showHangupPopup: true
                    })
                    let _this = this;
                    setTimeout(() => {
                        console.log("host hangup host_hangup 4 =>", localStorage.getItem("uniqueID"))
                        _this.setState({
                            showHangupPopup: false
                        })
                        if (localStorage.getItem("uniqueID")) {
                            console.log("host hangup host_hangup 5 =>")
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("Translate.messages.hostHangUpProcessing"),
                            }));
                        }
                    }, 15000)

                    setTimeout(() => {
                        console.log("host hangup host_hangup 6 =>", usersData, isDisconnectListened)
                        dispatch(hideApiLoader());
                        if (usersData && !isDisconnectListened) {
                            console.log("host hangup host_hangup 7 =>")
                            dispatch(setDeviceContainerStatus("hostUnpair", 'host_hangup'))
                            showAppToast(ct("rta-trmc.hostHangup.eventNotRecieved"), 10000);
                        }
                        dispatch(setHostHangupEventReceived(false, 0))
                        if (isDisconnectListened) {
                            dispatch(setIsDisconnectListened(false))
                        }
                    }, 60000)
                }
            } catch (e) {
                console.log("host_hangup error =>", e)
            }
        })

        // Bypass Pre-Joining screen in music mode process
        let musicModeTimer = sessionStorage.getItem("musicModeTimer")
        if (musicModeTimer) {
            let validUser = calculateTimeDiff(musicModeTimer, 60)
            if (validUser) {
                dispatch(setAlwaysShowPreJoining(false))
                setTimeout(() => {
                    sessionStorage.removeItem("musicModeTimer")
                    dispatch(setAlwaysShowPreJoining(true))
                }, 45000)
            }
        }

        socketOn("manage_host_rooms_return", data => {
            try {
                const { roomorIpAddress } = this.props
                if (data.currentRoom == CURRENT_ROOM_NAME || data.currentRoom == roomorIpAddress) {
                    dispatch(setRoomorIpAddress(data.newRoom, "manage_host_rooms_return"))
                }
            } catch (e) {
                console.log("manage_host_rooms_return error =>", e)
            }
        })

        socketOn("symmetric_participant_request", data => {
            try {
                const { roomorIpAddress, usersData } = this.props
                if (data.room == CURRENT_ROOM_NAME || data.room == roomorIpAddress) {
                    if (usersData && usersData.isHost) {
                        dispatch(setConfirmationModalProps({
                            isShow: true,
                            title: data.isFirewall ? ct("rta-trmc.firewall.firewallPermissionTitle") : ct("rta-trmc.natType.natTypePermissionTitle"),
                            content: data.isFirewall ? ct("rta-trmc.firewall.firewallPermissionContent") : ct("rta-trmc.natType.natTypePermissionContent"),
                            successBtnName: ct("rta-trmc.natType.natTypePermissionAllowBtn"),
                            cancelBtnName: ct("rta-trmc.natType.natTypePermissionRejectBtn"),
                            onSuccess: () => {
                                dispatch(setConfirmationModalProps({ isShow: false }));
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("rta-trmc.natType.natTypeThirdPartyLoader"),
                                }));
                                dispatch(thirdPartyMakeHostApi({
                                    roomName: roomorIpAddress,
                                    newRoomName: data.thirdParty,
                                    visibleRoom: CURRENT_ROOM_NAME
                                }).then((res) => {
                                    if (res.status == 1) {
                                        socketEmit('symmetric_participant_response', {
                                            roomName: CURRENT_ROOM_NAME,
                                            isAllowed: true,
                                            thirdParty: data.thirdParty,
                                            isFirewall: data.isFirewall,
                                        });
                                    } else {
                                        dispatch(hideApiLoader());
                                    }
                                    return false;
                                })
                                );
                            },
                            onCancel: () => {
                                dispatch(setConfirmationModalProps({ isShow: false }));
                                socketEmit('symmetric_participant_response', {
                                    roomName: CURRENT_ROOM_NAME,
                                    isAllowed: false,
                                    isFirewall: data.isFirewall,
                                });
                            }
                        }));
                    }
                }
            } catch (e) {
                console.log("symmetric_participant_request error =>", e)
            }
        })

        socketOn("symmetric_participant_response_return", data => {
            try {
                const { roomorIpAddress, usersData, isNatType } = this.props
                if (data.roomName == CURRENT_ROOM_NAME || data.roomName == roomorIpAddress) {
                    if (usersData && usersData.isHost) {
                        if (data.isAllowed) {
                            dispatch(setConfirmationModalProps({ isShow: false }));
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("rta-trmc.natType.natTypeThirdPartyLoader"),
                            }));
                        } else {
                            dispatch(setConfirmationModalProps({ isShow: false }));
                        }
                    } else {
                        if (data.isAllowed) {
                            dispatch(setConfirmationModalProps({ isShow: false }));
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("rta-trmc.natType.natTypeThirdPartyLoader"),
                            }));
                            if (isNatType.type3) {
                                if (isNatType.type3Data != null || isNatType.type3Data != undefined) {
                                    const unpairData = {
                                        action: {
                                            uniqueID: isNatType.type3Data.uniqueID,
                                            ipAddress: isNatType.type3Data.ipAddress,
                                            protocolId: isNatType.type3Data.protocolId,
                                        },
                                        content: 'unpair-device',
                                        isBroadcast: true,
                                        sender: 'mobile',
                                        scope: "NAT unpair hit"
                                    }
                                    sendData(unpairData);
                                    setTimeout(() => {
                                        let { protocolId } = getStore(FEATURE_CUSTOM_REDUX)
                                        const message = {
                                            action: {
                                                uniqueID: isNatType.type3Data.uniqueID,
                                                ipAddress: data.thirdParty,
                                                protocolId: protocolId,
                                            },
                                            content: 'unique_check',
                                            isBroadcast: true,
                                            sender: 'mobile',
                                            scope: 'NAT pair hit'
                                        };
                                        sendData(message);
                                    }, 20000)
                                    dispatch(setIsNatType({
                                        type3: false,
                                        type3Data: {}
                                    }));
                                }
                            }
                        } else {
                            dispatch(hideApiLoader())
                            if (isNatType.type3) {
                                const unpairData = {
                                    action: {
                                        uniqueID: isNatType.type3Data.uniqueID,
                                        ipAddress: isNatType.type3Data.ipAddress,
                                        protocolId: isNatType.type3Data.protocolId,
                                    },
                                    content: 'unpair-device',
                                    isBroadcast: true,
                                    sender: 'mobile',
                                    scope: "NAT unpair hit"
                                }
                                dispatch(setConfirmationModalProps({
                                    isShow: true,
                                    title: data.isFirewall ? ct("rta-trmc.firewall.firewallPermissionTitle") : ct("rta-trmc.natType.natTypePermissionTitle"),
                                    content: data.isFirewall ? ct("rta-trmc.firewall.firewallRejectedContent") : ct("rta-trmc.natType.natTypeRejectedContent"),
                                    successBtnName: ct("rta-trmc.natType.natTypeRejectedRetryBtn"),
                                    cancelBtnName: ct("rta-trmc.natType.natTypeRejectedCancelBtn"),
                                    onSuccess: () => {
                                        dispatch(setConfirmationModalProps({ isShow: false }));
                                        sendData(unpairData);
                                        localStorage.removeItem("uniqueID");
                                        dispatch(setEnableWebjamModal(true));
                                        dispatch(setIsNatType({
                                            type3: false,
                                            type3Data: {}
                                        }));
                                    },
                                    onCancel: () => {
                                        dispatch(setConfirmationModalProps({ isShow: false }));
                                        sendData(unpairData);
                                        localStorage.removeItem("uniqueID");
                                        dispatch(setIsNatType({
                                            type3: false,
                                            type3Data: {}
                                        }));
                                    }
                                }));
                            }
                        }
                    }
                }
            } catch (e) {
                console.log("symmetric_participant_request error =>", e)
            }
        })
    }



    componentWillUnmount() {
        this.componentCleanup();
        window.removeEventListener('beforeunload', this.componentCleanup);
        // remove the event handler for normal unmounting
    }

    componentDidUpdate(prevProps, prevState) {

        const {
            getLocalParticipant,
            clickMakeHost,
            deviceList,
            usersData,
            menuStatus,
            conferenceJoined,
            publicIp,
            ghostList,
            dispatch,
            metronomeStatus,
            roomorIpAddress,
            audioGhost,
            _iAmRecorder,
            whiteboardAssets,
            isDeviceListed,
            deviceContainerStatus,
            userLoginData,
            authOrganization,
            myRecordingsData,
            clickedAutoMakeHost,
            customTourAction,
            localAutoConnect,
            tourGuideType,
            serverConnectRehit,
            showDevicePreConnection,
            recordingDetails,
            stemRecordingUrl,
            stemRecording
        } = this.props;

        const {
            explorePop,
            isMenuOpen,
            isMixerShow,
            openTool,
            currentPage,
            selectedRecord,
            emptyHostTabData,
            autoHostData
        } = this.state;
        if (prevProps.stemRecordingUrl != stemRecordingUrl) {
            if (stemRecordingUrl && stemRecording && recordingDetails) {
                let recordingData = {
                    individual_url: stemRecordingUrl,
                    recordingName: recordingDetails.recordingName,
                    roomName: recordingDetails.roomName,
                }
                saveStemRecordingUrl(recordingData)
            }
        }

        if (prevState.currentPage != currentPage) {
            if (currentPage == 1) {
                dispatch(getWhiteboardAssets("?organization_id=" + authOrganization._id + "&room_name=" + roomorIpAddress + "&page_num=" + currentPage))
            }
        }

        // Show the all tools open default based on config	
        if (prevState.isMenuOpen != isMenuOpen) {
            if (isMenuOpen) {
                this.setState({
                    isToolsOpen: getBaseConfig("isExploreOpen") || false,
                    isSubToolsOpen: getBaseConfig("isSubToolsOpen") || false,
                    isAudioToolsOpen: getBaseConfig("isAudioToolsOpen") || false,
                })
            }
        }

        if (prevProps.roomorIpAddress !== roomorIpAddress) {
            let noChangedRoomName = getBaseConfig('noChangedRoomName')
            let roomorIpAddressNew = roomorIpAddress
            if (noChangedRoomName == true) {
                if (roomorIpAddressNew) {
                    if (roomorIpAddressNew?.indexOf("_") != -1) {
                        roomorIpAddressNew = roomorIpAddressNew?.replace("_", ":")
                    }
                }
            }
            // if (localStorage.getItem('makeHostConnect') == 'true') {
            //     let savedUniqueid = localStorage.getItem("uniqueID");
            //     let hostTimer = setTimeout(() => {
            //         if (localStorage.getItem('makeHostConnect') == 'true') {
            //             // hideLoader("make-host-disconnect");	
            //             // if (hostTimer) {	
            //             //     clearTimeout(hostTimer);	
            //             // }	
            //             // dispatch(hideApiLoader("make-host-disconnect"));
            //             // const message = {
            //             //     action: {
            //             //         uniqueID: savedUniqueid,
            //             //         ipAddress: roomorIpAddressNew,
            //             //         protocolId: localStorage.getItem("timeStamp")
            //             //     },
            //             //     content: 'unique_check',
            //             //     isBroadcast: true,
            //             //     sender: 'mobile'
            //             // };
            //             // sendData(message);
            //         }
            //     }, 15000);
            //     setTimeout(() => {
            //         if (hostTimer) {
            //             clearTimeout(hostTimer);
            //             //hideLoader("make-host-disconnect");	
            //             dispatch(hideApiLoader("make-host-disconnect"));
            //         }
            //     }, 20000);
            // }

            if (ipAddress === "1.1.1.1") {
                dispatch(maybeRedirectToWelcomePage({ "feedbackSubmitted": false, "showThankYou": false }));
                return false;
            }

            if (roomorIpAddressNew && roomorIpAddressNew?.includes('.melomax.cloud')) {
                (async () => {
                    var response = await fetch('https://dns.google/resolve?name=' + roomorIpAddressNew);
                    var json = await response.json();
                    displayConsole("RESOLVE RESPONSE FROM DNS: ", json);
                    if (json && json.Answer) {
                        ipAddress = json.Answer[0].data;

                        //action to set room name or ipAddress used to connect present room
                        let noChangedRoomName = getBaseConfig('noChangedRoomName')
                        if (noChangedRoomName == true) {
                            if (_ValidateIPaddress(ipAddress)) {
                                if (ipAddress && ipAddress.indexOf("_") != -1) {
                                    ipAddress = ipAddress.replace("_", ":")
                                }
                            }
                        }
                        dispatch(setRoomorIpAddress(ipAddress, 'layout componentDidUpdate'));
                        //lingering-field-two.melomax.cloud
                        if (ipAddress === "1.1.1.1") {
                            dispatch(maybeRedirectToWelcomePage({ "feedbackSubmitted": false, "showThankYou": false }));
                            return false;
                            // } else {
                            //     window.location.href = '/ipAddress';
                            //     window.location.reload();
                        }
                    }
                })();
            }

            if (isNumeric(roomorIpAddressNew?.replace(/%20/g, ''))) {
                Toast(ct("messages.invalidNumericRoom", "messages"), Constant.App.ToastTime.LongCloseTime);

                // social url change code
                let socialAllowed = getBaseConfig("socialAllowed");
                if (socialAllowed == true) {
                    window.parent.location.href = getBaseConfig('socialReferrerUrl') + '/OuIVuX07';
                } else {
                    window.location.href = '/';
                }
                dispatch(maybeRedirectToWelcomePage({ "feedbackSubmitted": false, "showThankYou": false }));
                //this.props.dispatch(disconnect(true));
                return false;
            }
        }

        //if (SessionId !== openByUser) {
        if (prevProps.metronomeStatus !== metronomeStatus && metronomeStatus === true) {
            setTimeout(() => {
                openByUser = "other";
                this.setState({
                    openTool: 'box-metronome'
                });
            }, 1000);
        }
        //}

        if (prevProps.metronomeStatus !== metronomeStatus && metronomeStatus === false && openTool == 'box-metronome') {
            openByUser = "";
            this.setState({
                openTool: ''
            });
        }

        // Mixer screen is not showing when changing buffer delay by host
        if (prevProps.usersData != usersData) {

            // erase the lighting icon current state when user pair with box at very first time
            if ((prevProps.usersData == null || prevProps.usersData == undefined) && (usersData != null || usersData != undefined)) {
                dispatch(setDeviceContainerStatus("", 'index layout update'))

            }

            if ((prevProps.usersData == null || !prevProps.usersData || prevProps.usersData == "" || prevProps.usersData == "null") && usersData) {
                // holding flag when device connected on prejoin screen
                if (!serverConnectRehit) {
                    this.setState({ explorePop: 'webjam-mixer', isMenuOpen: false, isMixerShow: true });
                } else {
                    dispatch(showApiLoader({
                        loaderAdditionalDetail: ct("Translate.messages.serverConnectRehitLoader"),
                    }));
                }
            }

            if (prevProps.usersData != null && usersData == null) {
                // hide mixer modal if buffer delay has changed, add more ...
                this.setState({
                    explorePop: ""
                })
            }
        }

        // SHOW MIXER POPUP IF DEVICE IS CONNECTED IN WEBJAM POPUP
        if (prevProps.usersData !== usersData && (explorePop == "webjam" || explorePop == "auto-popup" || localStorage.getItem("autopopup") == "auto-popup")) { //&& !isMixerShow
            //show device popup when connected new device
            this.setState({ explorePop: 'webjam-mixer', isMenuOpen: false, isMixerShow: true });
            if (getBaseConfig("customTutorial") == true) {
                let _This = this;

                setTimeout(function () {
                    let showTourGuide = localStorage.getItem("showTourGuide")
                    if (showTourGuide || window.location.href.indexOf("AUDIO_GHOST") != -1 || _This.props.iAmRecorder) {
                        dispatch(setCustomTourAction(false))
                        _This.setState({
                            takeTour: false,
                        });
                    } else {
                        _This.setState({
                            takeTour: true,
                        });
                        dispatch(setCustomTourAction(true))
                    }
                }, 2000)
            }
            // Need to set a local var if device is not auto connect
            // 26 may
            this.setState({
                showDeviceHelpModal: true
            })
            localStorage.removeItem("autopopup");
        }

        if (!isEqual(prevState.user, this.state.user)) {
            // displayConsole("^^^^^ 111111 ", this.state.user)
            if (sessionStorage.getItem("isPaid") === 'false') {
                // if (ghostList && ghostList.length > 0) {
                //let demoList = ['abc', 'efg', '203.129.220.82'];
                // let ghostfound = ghostList.find(p => p === publicIp);
                if (_iAmRecorder) {


                } else {
                    setTimeout(() => {
                        this.paymentPop();
                    }, 3000);
                }
                // }
            } else {
                if (_iAmRecorder) {
                    if (!sessionStorage.getItem("willConnect")) {
                        sessionStorage.setItem("willConnect", 1)
                        window.location.reload();
                    }
                }
            }
        }

        //coNNNECT dEVICE WITH PRIVATE ROOM CHECK
        //if ((prevProps.deviceList != deviceList) && (!this.state.user.isPasswordProtected || (this.state.user && this.state.user.room && this.state.user.room.otherUsers.length && ((this.state.user.room.userName === this.state.user.username) || (this.state.user.room.otherUsers.indexOf(this.state.user.username) !== -1))))) {
        // Auto Manage Host Functionality
        // if ((prevProps.deviceList != deviceList) && (!this.state.user.isPasswordProtected || (this.state.user && this.state.user.room && (this.state.user?.room?.userName === this.state?.user?.username)))) {

        // check when devices length is actually change

        if (prevProps.deviceList != deviceList) {
            const { isUserLogin, uniqueId, isParticipantThirdPartyListen, isModeratorThirdPartyListen, boxDeviceErrorInfo } = this.props;
            if (boxDeviceErrorInfo.error.length) {
                return false
            }

            // if (isUserLogin) {
            if (conferenceJoined == true) {
                if (prevProps?.deviceList?.length < deviceList?.length) {
                    if (usersData == undefined || usersData?.uniqueID != localStorage?.getItem("uniqueID")) {
                        setTimeout(() => {
                            if (!serverConnectRehit) {
                                dispatch(setEnableWebjamModal(true));
                            } else {
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("Translate.messages.serverConnectRehitLoader"),
                                }));
                            }

                        }, 1000);
                    }
                }
            }
            // }

            if (_iAmRecorder) {
                // displayConsole("GHOST HERE 4")
            } else {
                let willShowDevice = true;
                // if (!usersData
                //     && conferenceJoined == true
                //     && isDeviceListed == true
                //     && deviceList.includes(localStorage.getItem("uniqueID"))) {
                //     willShowDevice = false;
                //     setTimeout(() => {
                //         this.autoConnectingDevice("isDeviceListed");
                //     }, 1000);
                // }
                let storeVersion1 = getStore(FEATURE_CUSTOM_REDUX);
                let storeVersion3 = getStore(FEATURE_CUSTOM_REDUX_V3);


                if ((storeVersion1.usersData == null || storeVersion1.usersData == undefined) &&
                    storeVersion1.conferenceJoined == true &&
                    (storeVersion1.deviceList.includes(localStorage.getItem("uniqueID")) || storeVersion1.deviceList.includes(storeVersion1.uniqueId)) &&
                    (storeVersion3.isParticipantThirdPartyListen == true || storeVersion3.isModeratorThirdPartyListen == true)
                    // localStorage.getItem("thirdPartyEventListened")
                ) {
                    this.autoConnectingDevice("setLocalThirdPartyEventListened");
                    dispatch(setParticipantThirdPartyEventListened(false))
                    dispatch(setModeratorThirdPartyEventListened(false))
                    // localStorage.removeItem("thirdPartyEventListened")
                }

                if (/*clickMakeHost != true &&*/ !usersData && explorePop != "webjam" && conferenceJoined == true) {
                    // if (localStorage.getItem("bufferValue")) {
                    if (storeVersion3.localBuffervalue) {
                        // if (deviceList.includes(localStorage.getItem("uniqueID"))) {
                        if (deviceList.includes(storeVersion1.uniqueId || localStorage.getItem("uniqueID"))) {
                            dispatch(setBufferLoader(false));
                            //localStorage.removeItem("bufferValue");
                            this.autoConnectingDevice();
                        } else {
                            dispatch(setBufferLoader(true));
                        }
                    } else {
                        dispatch(updateSettings({
                            userSelectedSkipPrejoin: true, //!userSelectedSkipPrejoin
                        }));

                        //WORKING PREVIOUS:
                        //(clickMakeHost == true || clickMakeHost == undefined)
                        let autoConnectAction = localStorage.getItem("autoConnect")
                        let noChangedRoomName = getBaseConfig('noChangedRoomName')
                        if (noChangedRoomName == true) {
                            autoConnectAction = localAutoConnect
                        }
                        if ((clickMakeHost != false && autoConnectAction && deviceList.includes(localStorage.getItem("uniqueID")))) {
                            // Need to set a local var if device is not auto connect
                            // 26 may
                            this.setState({
                                showDeviceHelpModal: true
                            })

                            setTimeout(() => {
                                //alert("yeshost"+clickMakeHost)
                                this.autoConnectingDevice();
                            }, 1000);
                        } else {

                            //DEVICE NOT AUTOCONNECT:
                            //alert("nohost"+clickMakeHost+ localStorage.getItem("autoConnect"))
                            console.log("device list changed ", localStorage.getItem("askAgain"))
                            if (clickMakeHost != true && !localStorage.getItem("askAgain") && explorePop == '') {
                                // HIDE AUTOCONNECT POPUP: 
                                if (!localStorage.getItem("newRoomHosted")) {
                                    if (willShowDevice == false) {
                                        this.setState({ explorePop: 'webjam', isMenuOpen: false });
                                    }
                                } else {
                                    // Need to set a local var if device is not auto connect
                                    // 26 may
                                    this.setState({
                                        showDeviceHelpModal: true
                                    })

                                    dispatch(hideApiLoader("loading..."));

                                    setTimeout(function () {
                                        dispatch(showApiLoader({
                                            loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                                            type: 14
                                        }));
                                    }, 200)

                                    setTimeout(function () {
                                        dispatch(hideApiLoader("loading..."));
                                    }, 30000)
                                }
                            }
                        }

                    }
                }
            }
            // }
        }

        // in case if device length is same / event listen after some time of flow
        if (prevProps.isModeratorThirdPartyListen != this.props.isModeratorThirdPartyListen) {
            let {
                isModeratorThirdPartyListen,
                isDeviceConnecting,
                hostEventReceived,
                uniqueId,
                usersData
            } = this.props
            if (isModeratorThirdPartyListen) {
                if (!isDeviceConnecting) {
                    if (hostEventReceived
                        && (hostEventReceived == HOST_RECEIVED_EVENTS.THIRD_PARTY_RECEIVED || hostEventReceived == HOST_RECEIVED_EVENTS.SELF_HOST_RECEIVED)) {
                        if (deviceList.includes(uniqueId) || deviceList.includes(localStorage.getItem("uniqueID"))) {
                            this.autoConnectingDevice("event listened late")
                        }
                    }
                }
            }
        }

        // Auto connect device when host hang up functionality is processing
        if (prevProps.hostHangupAutoConnect != this.props.hostHangupAutoConnect) {
            console.log("third-party-disconnect 10 =>", prevProps.hostHangupAutoConnect, this.props.hostHangupAutoConnect)
            let { hostHangupAutoConnect } = this.props
            console.log("third-party-disconnect 11 =>", hostHangupAutoConnect)
            if (hostHangupAutoConnect) {
                console.log("third-party-disconnect 13 =>")
                this.autoConnectingDevice("hostHangupAutoConnect")
            }
        }

        // COMMENT IT TO HIDE DEVICE POPUP ON START
        let ghostUSER = false;
        if (ghostList && ghostList?.length > 0) {
            //let demoList = ['abc', 'efg', '203.129.220.82'];
            ghostUSER = ghostList.find(p => p === publicIp);
        }
        // displayConsole("ghostUSER----- ", conferenceJoined);

        if (!usersData && explorePop != "webjam" && explorePop == '' && prevProps.conferenceJoined == false && conferenceJoined == true && ghostUSER == undefined /* (publicIp != "184.72.212.4") && !sessionStorage.getItem("askAgain")*/) {
            (async () => {
                var message = {
                    action: {
                        publicIp: publicIp,
                        userId: this.props?.userLoginData?.user?.id || null
                        //publicIp: "73.118.205.97"
                        //publicIp: "203.129.220.91",
                    },
                    content: 'device-list',
                    isBroadcast: true,
                    sender: 'mobile'
                }

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: '',
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                sendData(message);
            })();
        }
        // COMMENT IT TO HIDE DEVICE POPUP ON START
        // set tile view for jibri GHOST user
        // if (ghostList && ghostList.length > 0) {
        // let demoList = ['abc', 'efg', '203.129.220.82'];
        // let ghostfound = ghostList.find(p => p === publicIp);
        if (_iAmRecorder && (prevProps.conferenceJoined == false) && (conferenceJoined == true)) {
            // displayConsole("GHOST HERE 3");
            //action to set tile view for jibri user
            dispatch(setTileView(true))
        }
        // }
        // Check if user is login or not //hide modal
        let _this = this;
        const { paidRoomDetail, isUserLogin, invitedUserConfirm } = this.props;
        if (prevProps.paidRoomDetail.passwordProtected != paidRoomDetail.passwordProtected
            || prevProps.paidRoomDetail.isRoomPaid != paidRoomDetail.isRoomPaid
            || prevProps.paidRoomDetail.time != paidRoomDetail.time) {
            if (paidRoomDetail.isRoomPaid || paidRoomDetail.passwordProtected) {
                if (!isUserLogin) {
                    this.setState({
                        isLoginDialogOpen: true
                    });
                } else {
                    this.setState({
                        isLoginDialogOpen: false
                    });
                    if (paidRoomDetail.isUserMadePayment) {
                        if (paidRoomDetail.passwordProtected == true || userLoginData.isPasswordProtected == true) {
                            if (userLoginData.user.id && userLoginData.user.is_invited == true) {
                                this.setState({
                                    explorePop: ''
                                });
                            } else {
                                this.setState({
                                    explorePop: 'payment-pop'
                                });
                            }
                        } else if (paidRoomDetail.isRoomStarted) {
                            this.setState({
                                explorePop: ''
                            });
                            _startConference(20)
                            dispatch(setWaitingScreen(false));
                        } else {
                            this.setState({
                                explorePop: ''
                            });
                            dispatch(setWaitingScreen(true, 5));
                        }
                    } else {
                        if (userLoginData.user.id && userLoginData.user.is_invited == true) {
                            this.setState({
                                explorePop: ''
                            });

                            if (invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING) {

                            } else {
                                this.setState({
                                    explorePop: 'payment-pop'
                                });
                                if (paidRoomDetail.isRoomStarted) {
                                    dispatch(setWaitingScreen(false));
                                    //_startConference(21)
                                } else {
                                    dispatch(setWaitingScreen(true, 6))
                                    if (!userLoginData?.isAdmin && !userLoginData.isRoomStarted) {
                                        dispatch(setWaitingScreenStatus(true));
                                    }
                                }
                            }
                        } else {
                            if (userLoginData.user.id && userLoginData.user?.is_invited == true) {
                                if (paidRoomDetail.isRoomStarted || userLoginData?.isRoomStarted) {
                                    dispatch(setWaitingScreen(false));
                                    _startConference(21)
                                } else {
                                    dispatch(setWaitingScreen(true, 7));
                                }

                            } else {
                                this.setState({
                                    explorePop: 'payment-pop'
                                });
                            }

                            // if (userLoginData.user.id && userLoginData.user.is_invited == false) {
                            //     if (paidRoomDetail.isRoomStarted) {
                            //         dispatch(setWaitingScreen(false));
                            //         _startConference(21)
                            //     } else {
                            //         dispatch(setWaitingScreen(true))
                            //     }
                            // } else {
                            //     this.setState({
                            //         explorePop: 'payment-pop'
                            //     });
                            // }
                        }
                    }
                }
            } else {
                console.log("payment-pop else =>")
            }
        }

        if (prevProps.whiteboardAssets != whiteboardAssets) {
            whiteboardAssets.map((list, i) => {
                if (list.assets.length && list.category_name.indexOf("Audio") != -1) {
                    this.setState({
                        whiteboardAudio: true
                    })
                } else if (list.assets.length && list.category_name.indexOf("Files") != -1) {
                    this.setState({
                        whiteboardFiles: true
                    })
                }
            })
        }

        if (prevProps.deviceContainerStatus != deviceContainerStatus) {
            if (deviceContainerStatus) {
                if (deviceContainerStatus == 'open') {
                    this.setState({
                        explorePop: 'webjam',
                        isMenuOpen: false
                    })
                } else if (deviceContainerStatus == 'unpair') {
                    this.unpairWebjam()
                } else if (deviceContainerStatus == 'hostUnpair') {
                    this.disconnectRTA()
                }
            }
        }

        if (prevProps.isUserLogin != this.props.isUserLogin) {
            if (this.props.isUserLogin) {
                let hasConnect = getLJsonStorage("auth", "stripe_account_id");
                let hasVerified = getLJsonStorage("auth", "connectVerified");

                // if (hasConnect && hasVerified === "approved") {
                //     this.setState({
                //         stripeActivated: true
                //     })
                // }

                if (this.props.userLoginData?.user?.stripe_account_id
                    && this.props.userLoginData?.user?.connectVerified == connectAccountFlag.APPROVED) {
                    this.setState({
                        stripeActivated: true
                    })
                }
            }
        }

        if (prevProps.conferenceJoined != conferenceJoined) {
            if (conferenceJoined == true) {
                dispatch(setPrejoinPageVisibility(false, 17))
                socket.emit('get_open_tool', {
                    location: window.location.origin,
                    room: CURRENT_ROOM_NAME,
                    jitsiId: getLocalParticipant.id,
                })
            }
            // else if (!conferenceJoined) {
            //     let localSocketId = localStorage.getItem('socketId');
            //     socket.emit('get_open_tool', {
            //         location: window.location.origin,
            //         room: CURRENT_ROOM_NAME,
            //         socketId: localSocketId,
            //     })
            // }
        }

        const { toolModal } = this.props;

        if (prevProps.toolModal.toolName != toolModal.toolName) {
            if (toolModal.toolName) {
                if (toolModal.toolType == "menu-tool") {
                    if (toolModal.toolName == "login"
                        || toolModal.toolName == "signup"
                        || toolModal.toolName == "signin"
                        || toolModal.toolName == "forgot-password") {
                        this.setState({
                            isLoginDialogOpen: true,
                            isMenuOpen: false,
                            explorePop: ""
                        })
                    } else {
                        this.setState({
                            explorePop: toolModal.toolName,
                            isMenuOpen: false,
                            isLoginDialogOpen: false
                        })
                    }
                } else if (toolModal.toolType == "tools") {
                    this.setState({
                        openTool: toolModal.toolName,
                        isLoginDialogOpen: false,
                        explorePop: "",
                        isMenuOpen: false
                    })
                }
            }
        }

        // Update timer for pre-joining so after refresh it will not show
        if (conferenceJoined) {
            let showPreJoining = getBaseConfig('showPreJoining');
            if (showPreJoining) {
                let preJoiningSessionTime = sessionStorage.getItem("preJoinTimer")
                if (preJoiningSessionTime != null || preJoiningSessionTime != undefined) {
                    let validTime = calculateTimeDiff(preJoiningSessionTime, 10)
                    if (validTime) {
                        let preJoiningTimeStamp = Date.now();
                        sessionStorage.setItem("preJoinTimer", preJoiningTimeStamp)
                    }
                }
            }
        }

        // Conditions to show guide tour based on subscription plans
        if (conferenceJoined) {
            if (prevProps.tourGuideType != tourGuideType) {
                if (prevProps.tourGuideType == tourGuideActions.USER_EMPTY && tourGuideType == tourGuideActions.WITHOUT_DEVICE) {
                    dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_WITHOUT_DEVICE))
                }

                if (prevProps.tourGuideType == tourGuideActions.USER_EMPTY && tourGuideType == tourGuideActions.WITH_DEVICE) {
                    // Nothing will happen
                }

                if (prevProps.tourGuideType == tourGuideActions.WITH_DEVICE && tourGuideType == tourGuideActions.USER_HAS_BASIC_SUBSCRIPTION) {
                    dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_WITHOUT_DEVICE))
                }

                if (prevProps.tourGuideType == tourGuideActions.WITH_DEVICE && tourGuideType == tourGuideActions.USER_HAS_PREMIUM_SUBSCRIPTION) {
                    // Nothing will happen
                }

                if (prevProps.tourGuideType == tourGuideActions.USER_HAS_PREMIUM_SUBSCRIPTION && tourGuideType == tourGuideActions.USER_RECONNECTED) {
                    dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_WITH_DEVICE))
                }

                if (prevProps.tourGuideType == tourGuideActions.USER_EMPTY && tourGuideType == tourGuideActions.USER_STARTED_MANUALLY) {
                    if (usersData) {
                        dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_WITH_DEVICE))
                    } else {
                        dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_WITHOUT_DEVICE))
                    }
                }

            }
        }

        if (prevProps.showDevicePreConnection != showDevicePreConnection) {
            if (getBaseConfig("showPreJoiningInConference")) {
                if (document.getElementById("launcher")) {
                    if (showDevicePreConnection) {
                        document.getElementById("launcher").style.display = '';
                    } else {
                        document.getElementById("launcher").style.display = 'none';
                    }
                }
            }
        }

        const {
            socialSettingDialogStatus,
            hitFirewallApi
        } = this.props;

        if (prevProps.socialSettingDialogStatus != socialSettingDialogStatus) {
            if (socialSettingDialogStatus) {
                dispatch(openSettingsDialog(SETTINGS_TABS.PROFILE, true, 'social'));
                setTimeout(function () {
                    dispatch({
                        type: OPEN_DIALOG_FROM_SOCIAL,
                        socialSettingDialogStatus: false
                    })
                }, 2000)
            }
        }

        // START : To hit firewall API and run NAT type flow when host-exist event is received
        if (prevProps.hitFirewallApi != hitFirewallApi) {
            if (hitFirewallApi) {
                setTimeout(async function () {
                    const { uniqueId, roomorIpAddress, protocolId } = getStore(FEATURE_CUSTOM_REDUX)
                    const { prejoinScreenDetail } = getStore(FEATURE_CUSTOM_REDUX_V2);
                    try {
                        let getFirewallType = await getFirewallTypeApi({
                            uniqueID: uniqueId,
                            roomName: CURRENT_ROOM_NAME,
                            location: window.location.origin,
                        })

                        if (getFirewallType.status == 1) {
                            let firewallType = getFirewallType.data.type
                            if (firewallType == 1) {
                                console.log("Firewall Type 1 received =>")
                            } else if (firewallType == 2) {
                                // START : Unpair Device from previous room
                                const unpairData = {
                                    action: {
                                        uniqueID: uniqueId,
                                        ipAddress: roomorIpAddress,
                                        protocolId: protocolId,
                                    },
                                    content: 'unpair-device',
                                    isBroadcast: true,
                                    sender: 'mobile',
                                    scope: "getFirewallType"
                                }
                                sendData(unpairData);
                                // END : Unpair Device from previous room

                                // START : Change room name and pair device
                                dispatch(setRoomorIpAddress(getFirewallType.data.thirdParty));
                                setTimeout(() => {
                                    const pairData = {
                                        action: {
                                            uniqueID: uniqueId,
                                            ipAddress: getFirewallType.data.thirdParty,
                                            protocolId,
                                        },
                                        content: 'unique_check',
                                        isBroadcast: true,
                                        sender: 'mobile',
                                        scope: 'getFirewallType'
                                    };
                                    sendData(pairData);
                                }, 5000)
                                // END : Change room name and pair device

                                // START : Flush Pre-meeting states
                                dispatch(setPrejoinDeviceMessages({
                                    show: false,
                                    messages: {}
                                }, "device init reset"))
                                dispatch(setPrejoinSubscriptionUI({
                                    show_basic: false,
                                    basic_checking: "",
                                    show_premium: false
                                }))
                                dispatch(setPrejoinDeviceStepRunning(false, ""))
                                dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.DEFAULT))
                                dispatch(setPrejoinDeviceConnectTime(0))
                                // END : Flush Pre-meeting states
                            } else if (firewallType == 3) {
                                dispatch(setIsNatType({
                                    type3: true,
                                    type3Data: {
                                        uniqueID: uniqueId,
                                        ipAddress: roomorIpAddress,
                                        protocolId: protocolId,
                                    }
                                }));
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("rta-trmc.natType.natTypePermissionLoader"),
                                }));
                            }
                        }
                    } catch (e) {
                        console.log("checkFirewallType error =>", e)
                    }
                }, 10)
                dispatch(setHitFirewallApi(false));
            }
        }
        // END : To hit firewall API and run NAT type flow when host-exist event is received
    }

    componentCleanup = () => {
        const { openTool } = this.state;

        if (openTool && openByUser === SessionId) {
            localStorage.removeItem('isPitchActive');

            socket.emit('closetool', {
                location: CURRENT_ROOM_LOCATION
            });
        }
    }

    stripeSession = (res) => {

        if (res.hasOwnProperty("guidedTour")) {
            this.openCustomTour();
            let webjamConnectMessage = getBaseConfig("webJamConnected")
            dispatch(showToastPopup({ toastModal: true, modalText: webjamConnectMessage }));

        } else {
            this.setState({
                stripeSessionId: res
            })
        }
    }

    openToolStatus = (toolDetail, toolName = null) => {
        const { usersData, roomorIpAddress } = this.props;

        if (toolName == "box-metronome") {

            var message = {
                action: {
                    uniqueID: usersData?.uniqueId,
                    ipAddress: roomorIpAddress
                },
                content: 'stop-my-metronome',
                isBroadcast: true,
                sender: 'mobile'
            };

            if (toolDetail.isMain == true) {
                message.content = "stop-metronome"
            }

            this.setState({
                openTool: "",
                isMenuOpen: false,
                mediaDetail: "",
                toolOpenLocal: false,
                isManualOpen: false,
                toolDetail: ""
            })
            sendData(message);
        } else {
            this.setState({
                toolDetail
            })
        }
    }

    fetchMyRoomList = async () => {
        this.setState({ myRoomListLoading: true });
        const res = await getMyClaimedRoomsApi();
        this.setState({ myRoomListLoading: false });
        if (res.status == 1) {
            this.setState({
                myRoomList: res?.data
            })
        }
    }

    fetchOtherRoomList = async () => {
        this.setState({ otherRoomListLoading: true });
        const res = await getOtherRoomsApi();
        this.setState({ otherRoomListLoading: false });
        if (res.status == 1) {
            this.setState({
                otherRoomList: res?.data
            })
        }
    }

    async autoConnectingDevice(isBufferAutoConnect = '') {
        const { roomorIpAddress, isDeviceConnecting } = this.props
        console.log("third-party-disconnect 14 =>", roomorIpAddress)
        if (_ValidateIPaddress(roomorIpAddress)) {
            let isValid = await getIpValidation(roomorIpAddress);
            console.log("third-party-disconnect 15 =>", isValid)
            if (isValid.status == 2) {
                console.log("third-party-disconnect 16 =>")
                return false;
            }
        }

        const { dispatch } = this.props;
        //REMOVE BUFERVALUE AUTOCONNECT VARIABLE
        // localStorage.removeItem("bufferValue");
        dispatch(setHostHangupAutoConnect(false, 'third-party-disconnect autoConnectingDevice'));
        dispatch(setLocalBufferValue(false))

        let room = CURRENT_ROOM_NAME;
        // if (room) {
        //     room = room.substring(1);
        // }

        if (isDeviceConnecting) {
            return false;
        }

        dispatch(setIsDeviceListed(false));


        let time = Math.round(new Date().getTime() / 1000);
        let willTrigger = false;
        let prevConf = sessionStorage.getItem("conference_auto_" + room);
        if (prevConf) {
            if (!isNaN(prevConf)) {
                if (time - prevConf > 30) {
                    willTrigger = true;
                }
            } else {
                willTrigger = true;
            }
        } else {
            willTrigger = true;
        }

        console.log("third-party-disconnect 17 =>", willTrigger)

        if (willTrigger) {
            console.log("third-party-disconnect 18 =>")
            sessionStorage.setItem("conference_auto_" + room, time);
            const { protocolId, dispatch, connected, roomorIpAddress, bufferChangeUser, isBufferChange, hostTabData } = this.props;
            let noChangedRoomName = getBaseConfig('noChangedRoomName')
            let roomorIpAddressNew = roomorIpAddress
            if (noChangedRoomName == true) {
                // roomorIpAddressNew = await makeHostRoomStatus()
                roomorIpAddressNew = roomorIpAddress
                dispatch(setHostTabData({
                    ...hostTabData,
                    users: []
                }))
            }

            // send makeHostConnect if user change buffer delay
            if (bufferChangeUser == false && isBufferChange == false) {
                localStorage.setItem('makeHostConnect', 'true');
                // localStorage.setItem('thirdPartyMakeHostConnect', 'true');
            }

            const deviceId = localStorage.getItem("uniqueID");
            let obj = {
                uniqueId: deviceId,
                room: roomorIpAddressNew,
                connected
            }
            // }
            dispatch(setData(obj))
            //REMOVE AUTOCOOOOONNECT STORAGE VARIABLES
            localStorage.removeItem("makeHost");
            localStorage.removeItem("newRoomHosted");
            localStorage.removeItem("autoConnect");
            if (noChangedRoomName == true) {
                dispatch(setLocalAutoConnect(false));
            }
            localStorage.removeItem("uniqueID");
            let action = {
                uniqueID: deviceId,
                ipAddress: roomorIpAddressNew,
                protocolId,
            };

            // if (isBufferAutoConnect) {
            //     action.hostBuf = true;
            // }
            const message = {
                action: action,
                content: 'unique_check',
                isBroadcast: true,
                sender: 'mobile',
                scope: "1"
            };
            dispatch(setIsDeviceConnecting(true))
            dispatch(setHostEventReceived(""))

            setTimeout(function () {
                dispatch(setIsDeviceConnecting(false))
            }, 40000)
            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID || ' available',
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------
            sendData(message);

            // Hide webjam connected message
            dispatch(setHideWebjamConnectedMessage(true))
            setTimeout(function () {
                dispatch(setHideWebjamConnectedMessage(false))
            }, 30000)

            //TO OPEN MIXER BY DEFAULT AFTER AUTOCONNECTING DEVICE
            this.setState({ explorePop: "auto-popup" });
            // // auto connect fired again if box unexpectly not connected within 2.5 mins
            // let { usersData, deviceList, uniqueId } = getStore(FEATURE_CUSTOM_REDUX)
            // let _this = this;
            // setTimeout(() => {
            //     if ((!usersData || usersData == null || usersData == undefined) && (deviceList.includes(uniqueId) || deviceList.includes(localStorage.getItem("uniqueID")))) {
            //         dispatch(showApiLoader())
            //     }
            //     setTimeout(() => {
            //         if ((!usersData || usersData == null || usersData == undefined) && (deviceList.includes(uniqueId) || deviceList.includes(localStorage.getItem("uniqueID")))) {
            //             _this.autoConnectingDevice("not connected once so trying again")
            //         }
            //     }, 10000)
            // }, 3000)
        }
    }

    paymentPop = () => {
        const { user } = this.state;

        if (!user.isLogged) {
            this.setState({
                isLoginDialogOpen: true
            });
        } else {
            // this.setState({
            //     explorePop: 'payment-pop'
            // });
        }
    }

    // changing the style of menu
    changeMenu(menu) {
        this.setState({ currentMenu: menu });
    }

    // changing the side of the menu
    changeSide(side) {
        this.setState({ side });
    }

    // braodcast the current tool
    openTool(openTool, mediaDetail = '') {
        let obj = {
            openTool,
            isMenuOpen: false,
            mediaDetail,
            toolOpenLocal: true
        }

        if (openTool == "piano") {
            obj.isManualOpen = true
        } else {
            obj.isManualOpen = false
        }

        this.setState(obj);

        let type = "openTools";
        if (openTool == "piano") {
            type = "openTools_piano";
        } else if (openTool == "guitar-tuner") {
            socket.emit("guitar_tuner", {
                room: CURRENT_ROOM_LOCATION,
            });
        }
        let allowedToolSync = getBaseConfig("allowedToolSync");

        if (allowedToolSync.includes(openTool)) {
            socket.emit(type, {
                openTool,
                SessionId,
                location: CURRENT_ROOM_LOCATION,
                mediaDetail
            });
        }
        sendAnalytics({
            action: "toolbar-clicked",
            category: "toolbar",
            source: openTool
        });
    }

    // close tool
    closeTool() {
        const { metronomeStatus, metronomeTimerStatus, usersData, roomorIpAddress } = this.props;
        if (SessionId === openByUser) {
            //if(metronomeStatus !== metronomeTimerStatus) {
            if (this.state.openTool === "box-metronome" && openByUser !== "other") {
                const message = {
                    action: {
                        uniqueID: usersData?.uniqueId,
                        ipAddress: roomorIpAddress
                    },
                    content: 'stop-metronome',
                    isBroadcast: true,
                    sender: 'mobile'
                };
                displayConsole('stop-metronome 2222 ---- ', message);

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: message.action.uniqueID,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------
                sendData(message);
            }

            localStorage.removeItem('isPitchActive');
            this.setState({
                openTool: '',
                toolDetail: ''
            });

            setTimeout(() => {
                socket.emit('closetool', {
                    location: CURRENT_ROOM_LOCATION
                });
            }, 500);
        } else {
            //if(metronomeStatus !== metronomeTimerStatus) {
            //if(metronomeStatus) {
            if (this.state.openTool === "box-metronome" && openByUser === "other") {
                const message = {
                    action: {
                        uniqueID: usersData?.uniqueId,
                        ipAddress: roomorIpAddress
                    },
                    content: 'stop-my-metronome',
                    isBroadcast: true,
                    sender: 'mobile'
                };
                displayConsole('stop-my-metronome ---- ',);

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: message.action.uniqueID,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                sendData(message);
            }

            socket.emit('closetool', {
                location: CURRENT_ROOM_LOCATION
            });

            setTimeout(() => {
                this.setState({
                    openTool: '',
                    toolDetail: ''
                });
            }, 200)
        }
    }

    // state of the menu
    handleStateChange(state) {
        const { isChatOpened } = this.props;

        if (isChatOpened && state.isOpen) {
            this.setState({
                isMenuOpen: false
            })
            dispatch(closeChat())
            dispatch(setChatTranslatorStatus(false));
        }

        let menuElem = document.getElementsByClassName("bm-menu-wrap")
        if (menuElem) {
            let menuCs = menuElem[0];
            let targetElement = document.getElementsByClassName("bm-burger-button")[0];
            if (state.isOpen) {
                targetElement.style.left = (menuCs.offsetWidth) + "px";
                // targetElement.style.top = "25px";
                targetElement.style.transition = "left 0.5s";
                targetElement.style.opacity = "1000 !important";
            } else {
                targetElement.style.left = "0";
                // targetElement.style.top = "40px";
                // targetElement.style.transition = "left 1s";
                targetElement.style.opacity = "299 !important";
            }
            // }
        }
    }

    toggleTool() {
        const { isToolsOpen } = this.state;

        this.setState({
            isToolsOpen: !isToolsOpen
        })
    }

    //FOR WHITEBOARD TOOLS
    toggleSubTool() {
        const { isSubToolsOpen, isToolsOpen } = this.state;

        this.setState({
            isToolsOpen: isToolsOpen,
            isSubToolsOpen: !isSubToolsOpen,
        });
    }

    toggleAudioTool() {
        const { isAudioToolsOpen, isToolsOpen } = this.state;

        this.setState({
            isToolsOpen: isToolsOpen,
            isAudioToolsOpen: !isAudioToolsOpen,
        });
    }
    //----

    jamulusDailog(isJamDailogOpen) {
        this.setState({
            isJamDailogOpen,
            isMenuOpen: false,
        })
    }

    exploreTool() {
        const { isExploreOpen } = this.state;

        this.setState({
            isExploreOpen: !isExploreOpen
        })
    }

    openLoginDialog = (isLoginDialogOpen) => {
        const { user: { isLogged } } = this.state;

        this.setState({
            isLoginDialogOpen,
            isMenuOpen: false,
        });
    }

    closeLoginDialog = (res, type, signUpClose = '') => {
        this.openLoginDialog(res);

        if (signUpClose == "sign-up") {
            dispatch(setIsClaimClicked(false))
        } else if (!type) {
            dispatch(setIsClaimClicked(false))
        }
    }

    openUploadMediaDialog = () => {
        const {
            isUserLogin,
            userLoginData,
            dispatch,
        } = this.props
        const { claimedRoomEvent } = this.state;

        this.setState({ isMenuOpen: false })

        if (!isUserLogin && claimedRoomEvent) {
            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.uploadMedia.toAskPermissionMsg") }));
            setTimeout(function () {
                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
            }, 10000);
        } else if (!isUserLogin) {
            this.toSignInMsgModal()
        }

        if (isUserLogin && !userLoginData.isRoomClaimed) {
            this.toClaimMsgModal()
        }

        if (isUserLogin && userLoginData.isRoomClaimed && !userLoginData.isAdmin) {
            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.uploadMedia.toAskPermissionMsg") }));
            setTimeout(function () {
                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
            }, 10000);
        }

        if (isUserLogin && userLoginData.isRoomClaimed && userLoginData.isAdmin) {
            this.setState({ explorePop: 'upload' });
        }
    }

    toSignInMsgModal = () => {
        const {
            isUserLogin,
        } = this.props
        const { closeUploadMsgModals, claimedRoomEvent } = this.state
        return (
            <>
                {closeUploadMsgModals && !isUserLogin && !claimedRoomEvent &&
                    <GenericConfirmationModal
                        title={ct("rta-trmc.tools.uploadMedia")}
                        successBtnName={ct("rta-trmc.avatar.signIn")}
                        cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
                        content={ct("Translate.confirmationDialog.uploadMediaMsg")}
                        onSuccess={() => {
                            dispatch(setIsClaimClicked(true));
                            dispatch(setshowUploadModal(true));
                            this.openLoginDialog(true);
                            this.setState({ closeUploadMsgModals: false })
                        }}
                        onCancel={() => this.setState({ closeUploadMsgModals: false })} />
                }
            </>
        )
    }

    toClaimMsgModal = () => {
        const {
            isUserLogin,
            userLoginData,
        } = this.props
        const { closeUploadMsgModals, claimedRoomEvent } = this.state
        return (
            <>
                {closeUploadMsgModals && isUserLogin && !userLoginData.isRoomClaimed && !claimedRoomEvent &&
                    <GenericConfirmationModal
                        title={ct("rta-trmc.tools.uploadMedia")}
                        successBtnName={ct("Translate.confirmationDialog.claimBtn")}
                        cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
                        content={ct("Translate.confirmationDialog.uploadMediaMsg")}
                        onSuccess={() => {
                            dispatch(setshowUploadModal(true));
                            this.setState({ closeUploadMsgModals: false, explorePop: 'claim-room' });
                        }}
                        onCancel={() => this.setState({ closeUploadMsgModals: false })} />
                }
            </>
        )
    }

    setUser = (user) => {
        this.setState({
            user
        });
    }

    logoutUser = () => {
        const { user: { localIp, systemIp, browserSession } } = this.state;
        const config = {
            headers: {
                'content-type': 'application/json'
            }
        };

        const { dispatch, userLoginData, roomorIpAddress, getLocalParticipant, moderatorCount, authOrganization } = this.props;

        if (window.confirm(ct("Translate.messages.logoutText"))) {
            this.setState({
                closeUploadMsgModals: false,
                stripeActivated: false
            })
            // logout
            let getLocalAuth = localStorage.getItem("auth");
            if (getLocalAuth) {
                getLocalAuth = JSON.parse(getLocalAuth);
                if (getLocalAuth.hasOwnProperty("token")) {
                    userLogout({
                        ip: localIp,
                        systemIp: systemIp,
                        browser: browserSession
                    }, getLocalAuth.token)
                        .then((res) => {
                            if (res.status == 1) {
                                localStorage.removeItem("auth");
                                dispatch(setUserIsLogin(false));

                                if (userLoginData.isAdmin && moderatorCount == 0) {
                                    socketEmit('end_meeting_for_all', {
                                        // location: window.location.origin + roomorIpAddress,
                                        // jitsiUser: getLocalParticipant.id,
                                        // isAdminLeft: true
                                        organization_id: authOrganization._id
                                    });

                                } else {
                                    if (userLoginData.isRoomClaimed) {
                                        window.location.href = window.location.origin;
                                    }
                                }

                                try {
                                    dispatch(setUserLoginData({
                                        isAdmin: false,
                                        isOpenRoom: false,
                                        isAlreadyPaid: false,
                                        isLogged: false,
                                        isOpenRoom: false,
                                        isPrivate: false,
                                        isRoomClaimed: false,
                                        data: '',
                                        room: '',
                                        user: ''
                                    }, 4));
                                } catch (e) {
                                    console.log("setUserLoginData logout error =>", e)
                                }

                                this.setState({
                                    isLoginDialogOpen: false
                                })
                                Toast(ct("messages.logoutSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
                                sendAnalytics({
                                    action: 'sign-out',
                                    source: "toolbar",
                                    category: "sign out"
                                });

                                if (!getBaseConfig("guestUser")) {
                                    dispatch(disconnect(true));
                                }
                            } else {
                                Toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime);
                            }
                        }).catch(e => console.log("Logout failed error =>", e))
                        .finally((e) => {

                        })
                }
            }
            this.setState({
                isMenuOpen: false,
            });
        }
    }

    handlePairDevice = () => {
        const { _isLiveStreamRunning, _isRecordingRunning, isModerator } = this.props;

        if (_isLiveStreamRunning == false && _isRecordingRunning == false) {
            this.setState({
                explorePop: 'webjam',
                isMenuOpen: false
            })
            dispatch(setDeviceContainerStatus("open", 'handlePairDevice'))
        } else {
            this.setState({
                isMenuOpen: false
            })
            if (isModerator) {
                if (_isRecordingRunning) {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.recRestrictions.webjamModeratorMsg") }));
                } else {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.streamRestrictions.webjamModeratorMsg") }));
                }
            } else {
                if (_isRecordingRunning) {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.recRestrictions.webjamParticipantMsg") }));
                } else {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.streamRestrictions.webjamParticipantMsg") }));
                }
            }

            setTimeout(function () {
                dispatch(showToastPopup({ toastModal: false, modalText: "" }));
            }, 10000)
        }

    }

    handleUnpairDevice = () => {
        this.setState({ isMenuOpen: false });
        this.unpairWebjam()
    }

    disconnectWebjam = () => {
        const { protocolId, dispatch, usersData, roomorIpAddress } = this.props;
        dispatch(setDeviceContainerStatus("unpairWebjam", 'unpairWebjam'))
        const data = {
            action: {
                uniqueID: usersData.uniqueId,
                ipAddress: roomorIpAddress,
                protocolId,
            },
            content: 'unpair-device',
            isBroadcast: true,
            sender: 'mobile'
        }

        //-------------Prepare logger data -------------
        var log_data = {
            functionName: '',
            triggeredBy: 'system',
            event: data.content,
            requestData: data,
            responseData: '',
            userId: '',
            boxId: data.action.uniqueID,
            message: 'Emit to server'
        }
        SaveLog(log_data);
        //-------------------------------------------

        this.setState({
            isMenuOpen: false,
        })
        sendData(data);
        dispatch(setPrejoinScreenDetail({
            isSet: false,
            roomname: "",
            uniqueId: "",
            scope: "disconnect manual"
        }))
        setTimeout(() => {
            dispatch(showApiLoader())
        }, 2000)

        setTimeout(() => {
            dispatch(hideApiLoader())
        }, 10000)

        localStorage.removeItem("connectPop");
        let timeStamp = Date.now();
        sessionStorage.setItem("unpair", timeStamp);
        dispatch(setHostTabData(null));
        dispatch(setUsersData(null));
        dispatch(setHostInitWait(true));

    }

    disconnectRTA = () => {
        const { protocolId, dispatch, usersData, roomorIpAddress } = this.props;

        const data = {
            action: {
                uniqueID: usersData.uniqueId,
                ipAddress: roomorIpAddress,
                protocolId,
            },
            content: 'unpair-device',
            isBroadcast: true,
            sender: 'mobile'
        }

        //-------------Prepare logger data -------------
        var log_data = {
            functionName: '',
            triggeredBy: 'system',
            event: data.content,
            requestData: data,
            responseData: '',
            userId: '',
            boxId: data.action.uniqueID,
            message: 'Emit to server'
        }
        SaveLog(log_data);
        //-------------------------------------------

        this.setState({
            isMenuOpen: false,
        })
        sendData(data);
        dispatch(setDeviceContainerStatus("unpairWebjam", 'unpairWebjam'))
        dispatch(setPrejoinScreenDetail({
            isSet: false,
            roomname: "",
            uniqueId: "",
            scope: "disconnect manual"
        }))
        localStorage.removeItem("connectPop");
        localStorage.removeItem("uniqueID");
        let timeStamp = Date.now();
        sessionStorage.setItem("unpair", timeStamp);
        dispatch(setHostTabData(null));
        dispatch(setUsersData(null));
        dispatch(setHostInitWait(true));

    }

    unpairWebjam = () => {
        const { protocolId, dispatch, usersData, roomorIpAddress, uniqueId } = this.props;
        if (usersData && usersData.users && usersData.isHost) {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.confirmation"),
                content: ct("messages.confirmUnpairDevice", "messages"),
                //   "confirmUnpairDevice": "You are the host for the current room. Disconnecting will disconnect all other users from their RealTime Audio device in this room. Do you wish to continue?",
                onSuccess: () => {
                    if (getBaseConfig("hostHangupNew")) {
                        hostHangupNewApi({
                            room: roomorIpAddress,
                            location: window.location.origin,
                            uniqueID: uniqueId,
                            visibleRoom: CURRENT_ROOM_NAME,
                            actionType: 1 // 1 -> boxDisconnected, 2 -> roomDisconnected
                        });
                    }
                    this.disconnectWebjam();
                    dispatch(setConfirmationModalProps({ isShow: false }));
                },
                onCancel: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                    dispatch(setDeviceContainerStatus("unpairWebjam", 'unpairWebjam'))
                }
            }));
        } else {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.confirmation"),
                content: ct("Translate.messages.disconnectRTA"),
                onSuccess: () => {
                    this.disconnectRTA();
                    dispatch(setConfirmationModalProps({ isShow: false }));
                },
                onCancel: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                    dispatch(setDeviceContainerStatus("unpairWebjam", 'unpairWebjam'))
                }
            }));
        }
    }

    getAudio() {
        const { whiteboardAssets, userLoginData } = this.props;

        return whiteboardAssets.map((list, i) => {
            let viewMoreButton = <div></div>
            if (list.total_count > 5) {
                viewMoreButton = <li className="dd-list-item upload-media"
                    onClick={e => { e.preventDefault(); this.setState({ openMediaModal: true, allMediaType: 'Audio', isMenuOpen: false }); }}
                >{ct("rta-trmc.tools.viewMore")}</li>
            }
            if (list.assets.length && list.category_name.indexOf("Audio") != -1) {
                let mapFile = list.assets.map((file, j) => {
                    let deleteAction = <i></i>
                    if (userLoginData.isAdmin) {
                        deleteAction = <i className="fa fa-trash" title={ct("rta-trmc.dialogs.clickHereToDelete")} onClick={e => {
                            e.preventDefault();
                            this.deleteFile(file);
                            this.setState({ isMenuOpen: false });
                        }}></i>
                    }
                    return (
                        <div key={"media_file_" + i + "_" + j} className='d-flex align-items-center justify-content-center w-100 px-4'>
                            <li className={`dd-list-item ${list?.assets?.length === j + 1 ? 'last-li-child' : ''}`} onClick={e => {
                                e.preventDefault();
                                this.openTool("white-board", file);
                                this.setState({ mediaDetail: file })
                            }}
                            >
                                {this.getFileType(file.file_name)}
                            </li>
                            {deleteAction}
                        </div>
                    )
                })
                return <>{mapFile}{viewMoreButton}</>
            }
        })
    }

    getFiles() {
        const { whiteboardAssets, userLoginData } = this.props;
        return whiteboardAssets.map((list, i) => {
            let viewMoreButton = <div></div>
            if (list.total_count > 5) {
                viewMoreButton = <li className="dd-list-item upload-media"
                    onClick={e => { e.preventDefault(); this.setState({ openMediaModal: true, allMediaType: 'Files', isMenuOpen: false }); }}
                >{ct("rta-trmc.tools.viewMore")}</li>
            }
            if (list.assets.length && list.category_name.indexOf("Files") != -1) {
                let mapFile = list.assets.map((file, j) => {
                    let deleteAction = <i></i>
                    if (userLoginData.isAdmin) {
                        deleteAction = <i className="fa fa-trash" title={ct("rta-trmc.dialogs.clickHereToDelete")} onClick={e => {
                            e.preventDefault();
                            this.deleteFile(file);
                            this.setState({ isMenuOpen: false });
                        }}></i>
                    }
                    return (
                        <div key={"media_file_" + i + "_" + j} className={`d-flex align-items-center justify-content-center w-100 px-4 `}>
                            <li className={`dd-list-item ${list?.assets?.length === j + 1 ? 'last-li-child' : ''}`} onClick={e => {
                                e.preventDefault();
                                this.openTool("white-board", file);
                                this.setState({ mediaDetail: file })
                            }}
                            >
                                {this.getFileType(file.file_name)}
                            </li>
                            {deleteAction}
                        </div>
                    )
                })
                return <>{mapFile}{viewMoreButton}</>
            }
        })
    }

    getFileType(file) {
        const { allMediaType } = this.state;
        let fileType = file.split(".").pop().toLowerCase();
        let icon = '';
        if (fileType == "mp3") {
            icon = <i className="fa fa-file-audio-o"></i>
        } else {
            icon = <i className="fa fa-file-pdf-o"></i>
        }
        if (allMediaType == '') {
            if (file.length > 14) {
                // let splitFile = file.split("_").pop().split(".")[0];
                // let sliceFile = splitFile.slice(-3)
                // file = file.substr(0, 6) + "_" + sliceFile + "." + fileType;
                file = file.substr(0, 12) + "." + fileType;
            }
        }

        return (<>
            {icon}
            {' '}
            {file}
        </>);
    }

    deleteFile(file, length = null) {
        const { dispatch } = this.props;
        let dataToDelete = {
            "organization_id": file.organization_id,
            "room_name": file.room_name,
            "file_name": file.file_name,
            "category_id": file.category_id,
            "file_path": file.file_path
        }
        dispatch(setConfirmationModalProps({
            isShow: true,
            title: ct("Translate.typography.confirmation"),
            // content: `Are you sure you want to delete ${file.file_name} file?`,
            content: i18next.t("rta-trmc.dashboard.myRecording.deleteFile", { fileName: file.file_name }),
            onSuccess: () => {
                dispatch(deleteMediaFileApi(dataToDelete));
                dispatch(setConfirmationModalProps({ isShow: false }));
                if (this.state.currentPage == 1 && length === 1) {
                    this.setState({ openMediaModal: false, allMediaType: '', currentPage: 1 });
                } else if (length === 1) {
                    this.paginationHandler('prev');
                }
            }
        }));
    }

    getAllMedia() {
        const { whiteboardAssets, userLoginData } = this.props;
        const { allMediaType, currentPage } = this.state;

        if (allMediaType == 'Audio') {
            return whiteboardAssets.map((list, i) => {
                if (list.assets.length && list.category_name.indexOf("Audio") != -1) {
                    let mapFile = list.assets.map((file, j) => {
                        let deleteAction = <i></i>
                        if (userLoginData.isAdmin) {
                            deleteAction = <i
                                className="fa fa-trash"
                                title={ct("rta-trmc.dialogs.clickHereToDelete")}
                                onClick={e => {
                                    e.preventDefault();
                                    this.deleteFile(file, list.assets.length);
                                    this.setState({ isMenuOpen: false });
                                }}></i>
                        }
                        return (
                            <>
                                <div className='list-item-outer'>
                                    <li className="dd-list-item" title={file.file_name} onClick={e => {
                                        e.preventDefault();
                                        this.setState({ mediaDetail: file, openMediaModal: false, allMediaType: '', currentPage: 1 })
                                        this.openTool("white-board", file);
                                    }}
                                        key={"media_file_" + i + "_" + j}>
                                        {this.getFileType(file.file_name)}
                                    </li>
                                    {deleteAction}
                                </div>
                            </>
                        )
                    })
                    return <>{mapFile}</>
                }
            })
        }
        if (allMediaType == 'Files') {
            return whiteboardAssets.map((list, i) => {
                if (list.assets.length && list.category_name.indexOf("Files") != -1) {
                    let mapFile = list.assets.map((file, j) => {
                        let deleteAction = <i></i>
                        if (userLoginData.isAdmin) {
                            deleteAction = <i className="fa fa-trash" title={ct("rta-trmc.dialogs.clickHereToDelete")} onClick={e => {
                                e.preventDefault();
                                this.deleteFile(file, list.assets.length);
                                this.setState({ isMenuOpen: false });
                            }}></i>
                        }
                        return (
                            <>
                                <div className='list-item-outer'>
                                    <li className="dd-list-item" title={file.file_name} onClick={e => {
                                        e.preventDefault();
                                        this.openTool("white-board", file);
                                        this.setState({ mediaDetail: file, openMediaModal: false, allMediaType: '', currentPage: 1 })
                                    }}
                                        key={"media_file_" + i + "_" + j}>
                                        {this.getFileType(file.file_name)}
                                    </li>
                                    {deleteAction}
                                </div>
                            </>
                        )
                    })
                    return <>{mapFile}</>
                }
            })
        }
    }

    getTotalCount() {
        const { whiteboardAssets } = this.props;
        const { allMediaType } = this.state;
        let totalCount;
        let remainder;
        let dividend;
        let pageCount;
        if (allMediaType == 'Audio') {
            whiteboardAssets.map((list, i) => {
                if (list.assets.length && list.category_name.indexOf("Audio") != -1) {
                    totalCount = list.total_count
                }
            })
        }
        if (allMediaType == 'Files') {
            whiteboardAssets.map((list, i) => {
                if (list.assets.length && list.category_name.indexOf("Files") != -1) {
                    totalCount = list.total_count
                }
            })
        }
        dividend = totalCount / 5;
        remainder = totalCount % 5;
        if (remainder === 0) {
            pageCount = dividend
        } else {
            pageCount = parseInt(dividend + 1)
        }
        return pageCount
    }

    paginationHandler(action) {
        dispatch(showApiLoader())
        const { whiteboardAssets, authOrganization, roomorIpAddress } = this.props;
        const { allMediaType, currentPage } = this.state;
        let totalPages;
        let finalCurrentPage;
        if (action == 'prev') {
            totalPages = this.getTotalCount()
            finalCurrentPage = currentPage - 1;
        }

        if (action == 'next') {
            totalPages = this.getTotalCount()
            finalCurrentPage = currentPage + 1;
        }

        if (finalCurrentPage == 0) {
            finalCurrentPage = currentPage;
        }

        if (finalCurrentPage > totalPages) {
            finalCurrentPage = currentPage;
        }

        if (finalCurrentPage == NaN) {
            finalCurrentPage = 1;
        }

        this.setState({ currentPage: finalCurrentPage });
        dispatch(hideApiLoader())
        dispatch(getWhiteboardAssets("?organization_id=" + authOrganization._id + "&room_name=" + roomorIpAddress + "&page_num=" + finalCurrentPage))
    }

    mediaModal() {
        const { openMediaModal, currentPage, allMediaType } = this.state
        let overallPages = this.getTotalCount();

        return (
            <>
                {openMediaModal && currentPage &&
                    <Dialog
                        disableAutoHideOnSubmit={true}
                        disableBackdropClose={true}
                        hideCloseButton={false}
                        onCancel={() => this.setState({ openMediaModal: false, allMediaType: '', currentPage: 1 })}
                        cancel={{ hidden: true }}
                        ok={{ hidden: true }}
                        titleKey={`${ct("rta-trmc.dialogs.uploaded")} ${allMediaType} ${ct("rta-trmc.dialogs.media")}`}
                        rtaClassName="all-recordings-modal-wrapper all-uploaded-files"
                        testId='media-files-popup'

                    >
                        <div className="media-files" >
                            <>{this.getAllMedia()}</>
                        </div>
                        <div className='media-pagination'>
                            <Button className="prev-btn" onClick={e => { e.preventDefault(); this.paginationHandler('prev'); }}>
                                <i className='fa fa-angle-double-left' /> {ct("rta-trmc.dashboard.myRecording.prev")}
                            </Button>
                            <text className="page-counter" >
                                {currentPage}/{overallPages}
                            </text>
                            <Button className="next-btn" onClick={e => { e.preventDefault(); this.paginationHandler('next'); }} >
                                {ct("rta-trmc.dashboard.myRecording.next")} <i className='fa fa-angle-double-right' />
                            </Button>
                        </div>
                    </Dialog>
                }
            </>
        )
    }

    handleStripeDashboard = () => {
        dispatch(showApiLoader())
        getStripeLink()
            .then(async resp => {
                dispatch(hideApiLoader())
                if (resp.status == 1) {
                    let link = resp.data.data.link;
                    window.open(link, "_blank")
                } else {
                    if (resp?.message) {
                        let msg = await dynamicMessageLocale(resp.message);
                        toast(msg, Constant.App.ToastTime.LongCloseTime)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime)
                    }
                }
            })
    }

    handleStripeAccount = () => {
        this.setState({
            explorePop: "create-payment-account",
            isMenuOpen: false
        })
    }

    joinFromMyRooms = (roomName) => {
        this.setState({ isJoiningAnotherRoom: true, isMenuOpen: false, isViewMyRoomsModal: false, roomName });
    }

    openMyRecordings = () => {
        const { openRecordingsModal, recordings_start_date, recordings_end_date, selectedRoom, selectedRecord, hitApi } = this.state
        const { isMyRecordingsModal, myRecordingsData, authOrganization } = this.props
        const PostUrl = getBaseConfig("PostUrl");
        if (hitApi || isMyRecordingsModal) {
            dispatch(showApiLoader());
            dispatch(getMyRecordingsData('?page=1'));
            dispatch(setIsMyRecordingsModal(false));
            this.setState({ hitApi: false, openRecordingsModal: true })
            dispatch(hideApiLoader());
        }
        let totalPages = myRecordingsData?.data?.paginationData?.page?.totalPages;
        let latestPage = myRecordingsData?.data?.paginationData?.page?.currentPage;

        if (totalPages == undefined) {
            totalPages = 0
        }
        if (latestPage == undefined) {
            latestPage = 0
        }
        return (
            <>
                {(openRecordingsModal) &&
                    <Dialog
                        disableAutoHideOnSubmit={true}
                        disableBackdropClose={true}
                        hideCloseButton={false}
                        onCancel={() => this.setState({ openRecordingsModal: false })}
                        cancel={{ hidden: true }}
                        ok={{ hidden: true }}
                        titleKey={ct("rta-trmc.dialogs.allRecordings")}
                        rtaClassName="all-recordings-modal-wrapper"
                        testId='my-recordings-popup'
                        size='large'
                    >
                        <div className='my-recordings-dialog'>
                            {/* <ModalDialog
                            width={"1100px !important"}
                            height={"700px !important"}
                            testId='my-recordings-popup'
                        >
                            <ModalHeader className='my-recordings-header'>
                                All Recordings <div><span id='close-recording-modal' className="close device" onClick={() => this.setState({ openRecordingsModal: false })}><img src={cross} /></span></div>
                            </ModalHeader> */}
                            <div className="my-recordings-body" >
                                <div className='my-recordings-search'>
                                    <div className='row'>
                                        <div className='col-lg-3 col-md-6 col-sm-6'>
                                            <label>{ct("rta-trmc.dialogs.whatLookingFor")}</label>
                                            <input
                                                type="text"
                                                placeholder={ct("rta-trmc.dashboard.myRecording.searchByRecordName")}
                                                name="selectedRecord"
                                                id="selectedRecord"
                                                className="form-control"
                                                value={selectedRecord}
                                                onChange={(e) => {
                                                    this.searchMyRec(e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className='col-lg-2 col-md-6 col-sm-6'>
                                            <label>{ct("rta-trmc.dashboard.myRecording.fromDate")}</label>
                                            <DatePicker
                                                dateFormat="MM-dd-yyyy"
                                                onChange={(date) => this.handleRecDateChange({ recordings_start_date: date })}
                                                selected={recordings_start_date}
                                                value={recordings_start_date}
                                                placeholderText={ct("rta-trmc.dashboard.myRecording.from")}
                                                maxDate={new Date()}
                                                locale={localeCalender()}

                                            />
                                        </div>
                                        <div className='col-lg-2 col-md-6 col-sm-6'>
                                            <label>{ct("rta-trmc.dashboard.myRecording.toDate")}</label>
                                            <DatePicker
                                                dateFormat="MM-dd-yyyy"
                                                onChange={(date) => this.handleRecDateChange({ recordings_end_date: date })}
                                                selected={recordings_end_date}
                                                value={recordings_end_date}
                                                placeholderText={ct("rta-trmc.dashboard.myRecording.to")}
                                                minDate={recordings_start_date}
                                                maxDate={new Date()}
                                                locale={localeCalender()}

                                            />
                                        </div>
                                        <div className='col-lg-3 col-md-6 col-sm-6 maxW'>
                                            <label>{ct("rta-trmc.dashboard.myRecording.roomName")}</label>
                                            <select
                                                name="selectedRoom"
                                                id="selectedRoom"
                                                className="form-control"
                                                value={selectedRoom}
                                                onChange={(e) => this.setState({ selectedRoom: e.target.value })}
                                            >
                                                <option selected disabled>{ct("rta-trmc.dashboard.myRecording.selectRomName")}</option>
                                                {(myRecordingsData?.data?.allRoomNames || []).map((item, index) => {
                                                    return (
                                                        <option value={item}>{item}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className='col-lg-2 col-md-6 col-sm-6'>
                                            <div className='w-100 d-flex'>
                                                <Button className='rec-filter-btn mr-4' onClick={e => { e.preventDefault(); this.hitRecSearchApi("searchAll"); }}>
                                                    {ct("rta-trmc.dashboard.myRecording.filter")}
                                                </Button>
                                                {(selectedRecord != '' || recordings_start_date != '' || recordings_end_date != '' || selectedRoom != 'Select Room Name') &&
                                                    <Button
                                                        className='rec-clear-filter-btn'
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.setState({
                                                                selectedRecord: '',
                                                                recordings_start_date: '',
                                                                recordings_end_date: '',
                                                                selectedRoom: ct("rta-trmc.dashboard.myRecording.selectRomName"),
                                                                searchApi: false,
                                                            });
                                                            dispatch(getMyRecordingsData('?page=1'))
                                                        }}>
                                                        {ct("rta-trmc.dashboard.myRecording.clear")}
                                                    </Button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='my-recordings-listing'>
                                    <table className="table table-hover">
                                        <thead id='all-recording-table-heading'>
                                            <tr>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.recordName")}</th>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.roomName")}</th>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.date")}</th>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.startTime")}</th>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.fileSize")}</th>
                                                <th scope="col">{ct("rta-trmc.dashboard.myRecording.action")}</th>
                                            </tr>
                                        </thead>
                                        {myRecordingsData?.data?.recordingData?.length !== undefined &&
                                            <tbody id='all-recording-table-body'>
                                                {(myRecordingsData?.data?.recordingData || []).map((item, index) => {
                                                    let recDate = moment(item.createdAt).locale("en").format('LL');
                                                    let recTime = moment(item.createdAt).locale("en").format('LT');
                                                    let fbShareUrl = getBaseConfig("FbPostUrl") + "/" + authOrganization.name + "/recordings" + "?name=" + item?.recording_name + ".mp4";
                                                    let recLink = getBaseConfig("recordingUrl") + "/" + authOrganization.name + "/recordings/" + item?.recording_name + ".mp4";
                                                    return (
                                                        <tr>
                                                            <td>{item.recording_name}</td>
                                                            <td>{item.room}</td>
                                                            <td>{recDate}</td>
                                                            <td>{recTime}</td>
                                                            <td>{item.size}</td>
                                                            <td className='table-social'>
                                                                <div className='social-icon-wrapper'>




                                                                    <i
                                                                        className="fa fa-download my-recordings-icons"
                                                                        title={ct("rta-trmc.dialogs.clickHereToDownload")}
                                                                        onClick={e => { e.preventDefault(); this.downloadRecording(item); }}
                                                                    />
                                                                    <i
                                                                        className="fa fa-link my-recordings-icons"
                                                                        title={ct("rta-trmc.dialogs.clickHereToCopy")}
                                                                        onClick={e => { e.preventDefault(); this.copyUrl(item); }}
                                                                    />
                                                                    <i>

                                                                        <FacebookShareButton
                                                                            url={fbShareUrl}
                                                                            quote={PostUrl}
                                                                            description={getBaseConfig("name") + " " + ct("rta-trmc.conference.videoLinkHere")}
                                                                            hashtag={"#" + getBaseConfig("name")}>
                                                                            <><i
                                                                                className="fa fa-facebook-official my-recordings-icons"
                                                                                title={ct("rta-trmc.dialogs.clickHereToShareOnFb")}
                                                                            /></>
                                                                        </FacebookShareButton>

                                                                    </i>

                                                                    <i>
                                                                        <a href={`mailto:max.mustermann@example.com?body=Here is the link to your recording: ${recLink}`}>
                                                                            <i
                                                                                className="fa fa-envelope-o my-recordings-icons"
                                                                                title={ct("rta-trmc.dashboard.myRecording.shareRecording")}
                                                                            />
                                                                        </a>
                                                                    </i>


                                                                    <i
                                                                        className="fa fa-trash my-recordings-icons"
                                                                        title={ct("rta-trmc.dashboard.myRecording.deleteRecording")}
                                                                        onClick={e => { e.preventDefault(); this.deleteRecording(item._id); }}
                                                                    />

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        }
                                    </table>
                                    {(myRecordingsData?.data?.recordingData.length == undefined || myRecordingsData?.data?.recordingData.length == 0) &&
                                        <div className='no-rec-data'>{ct("rta-trmc.dashboard.myRecording.noRecordingData")}</div>
                                    }
                                </div>
                            </div>
                            <ModalFooter className='my-recordings-pagination'>
                                {latestPage > 1 ?
                                    <Button id='prev-btn' className="prev-btn" onClick={e => { e.preventDefault(); this.myRecPagination('prev'); }}>
                                        <i className='fa fa-angle-double-left' /> {ct("rta-trmc.dashboard.myRecording.prev")}
                                    </Button>
                                    :
                                    <Button id='prev-btn' className="prev-btn disabled-rec">
                                        <i className='fa fa-angle-double-left' /> {ct("rta-trmc.dashboard.myRecording.prev")}
                                    </Button>
                                }
                                {totalPages >= 1 &&
                                    <text className="page-counter" >
                                        {latestPage}/{totalPages}
                                    </text>
                                }
                                {latestPage < totalPages ?
                                    <Button id='next-btn' className="next-btn" onClick={e => { e.preventDefault(); this.myRecPagination('next'); }} >
                                        {ct("rta-trmc.dashboard.myRecording.next")} <i className='fa fa-angle-double-right' />
                                    </Button>
                                    :
                                    <Button id='next-btn' className="next-btn disabled-rec" >
                                        {ct("rta-trmc.dashboard.myRecording.next")} <i className='fa fa-angle-double-right' />
                                    </Button>
                                }
                            </ModalFooter>
                            {/* </ModalDialog > */}
                        </div>
                    </Dialog>
                }
            </>
        )
    }

    hitRecSearchApi = (type) => {
        dispatch(showApiLoader());
        const { recordings_start_date, recordings_end_date, selectedRoom, selectedRecord } = this.state
        const { myRecordingsData } = this.props
        let latestPage = myRecordingsData?.data?.paginationData?.page?.currentPage;
        let previousPage = myRecordingsData?.data?.paginationData?.page?.prevPage;
        let nextPage = myRecordingsData?.data?.paginationData?.page?.nextPage;
        let recFromDate = moment(recordings_start_date).format("YYYY-MM-DD");
        let recToDate = moment(recordings_end_date).format("YYYY-MM-DD");
        let pageNumber = 1;

        if (recFromDate == 'Invalid date' || recToDate == 'Invalid date') {
            recFromDate = ''
            recToDate = ''
        }

        if (type == "delete") {
            pageNumber = latestPage;
        }

        if (type == "prevPage") {
            pageNumber = previousPage;
        }

        if (type == "nextPage") {
            pageNumber = nextPage;
        }

        if (selectedRoom && selectedRoom == 'Select Room Name') {
            dispatch(searchMyRecordingsData('?room=' + '' + '&recording_name=' + selectedRecord?.toLowerCase() + '&fromDate=' + recFromDate + '&toDate=' + recToDate + '&page=' + pageNumber))
        } else {
            dispatch(searchMyRecordingsData('?room=' + selectedRoom + '&recording_name=' + selectedRecord?.toLowerCase() + '&fromDate=' + recFromDate + '&toDate=' + recToDate + '&page=' + pageNumber))
        }
        dispatch(hideApiLoader());
    }

    handleRecDateChange = (date) => {
        if (date.recordings_start_date) {
            this.setState({
                recordings_start_date: date.recordings_start_date,
                recordings_end_date: ''
            })
        } else if (date.recordings_end_date) {
            const { recordings_start_date } = this.state
            if (recordings_start_date == '') {
                dispatch(setConfirmationModalProps({
                    isShow: true,
                    title: ct("Translate.typography.alert"),
                    content: ct("rta-trmc.premeeting.selectDateFirst"),
                    showCancelButton: false,
                    successBtnName: ct("Translate.buttonTitle.okSmall"),
                    onSuccess: () => {
                        dispatch(setConfirmationModalProps({ isShow: false }));
                    }
                }));

            } else {
                this.setState({
                    recordings_start_date: recordings_start_date,
                    recordings_end_date: date.recordings_end_date
                })
            }

        }
    }

    deleteRecording = (recordingId) => {
        const { dispatch } = this.props;
        dispatch(setConfirmationModalProps({
            isShow: true,
            title: ct("Translate.typography.confirmation"),
            content: ct("Translate.messages.deleteRecording"),
            onSuccess: () => {
                dispatch(deleteMyRecording(recordingId, () => {
                    this.hitRecSearchApi("delete");
                }))
                dispatch(setConfirmationModalProps({ isShow: false }));
            },
            onCancel: () => {
                dispatch(setConfirmationModalProps({ isShow: false }));
            }
        }));

    }

    myRecPagination = (action) => {
        dispatch(showApiLoader());
        const { searchApi } = this.state
        const { myRecordingsData } = this.props
        let previousPage = myRecordingsData?.data?.paginationData?.page?.prevPage;
        let nextPage = myRecordingsData?.data?.paginationData?.page?.nextPage;

        if (action == 'prev') {
            if (previousPage > 0) {
                if (searchApi) {
                    this.hitRecSearchApi("prevPage")
                } else {
                    dispatch(getMyRecordingsData('?page=' + previousPage))
                }
            }
        }

        if (action == 'next') {
            if (nextPage > 0) {
                if (searchApi) {
                    this.hitRecSearchApi("nextPage")
                } else {
                    dispatch(getMyRecordingsData('?page=' + nextPage))
                }
            }
        }
        dispatch(hideApiLoader());
    }

    debounce = (callback, delay) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => callback(...args), delay);
        }
    }

    debounceLog = this.debounce(input => {
        return this.hitRecSearchApi("search", input);
    }, 1000)

    searchMyRec = (input) => {
        let value = input.trim();

        if (!input.length || value.length) {
            this.setState({ selectedRecord: value, searchApi: true })
            // dispatch(showApiLoader());
            this.debounceLog(input)
        }
    }

    copyUrl = (data) => {
        const { authOrganization } = this.props
        const recLink = getBaseConfig("recordingUrl") + "/" + authOrganization.name + "/recordings/" + data?.recording_name + ".mp4";
        copyText(recLink)
        toast(ct("rta-trmc.dashboard.myRecording.recordingLink"), Constant.App.ToastTime.LongCloseTime)
    }

    downloadRecording = (data) => {
        const { authOrganization, chatFiles } = this.props
        let recordingUrl = getBaseConfig("recordingUrl") + "/" + authOrganization.name + "/recordings/" + data?.recording_name + ".mp4";
        let recdownload = [{
            name: data?.recording_name,
            file: recordingUrl,
            filename: data?.recording_name + ".mp4",
        }]
        if (data.individual_url) {
            let individualUrlData = {
                name: data?.recording_name,
                file: data.individual_url,
                filename: data?.recording_name + ".zip",
            }
            recdownload.push(individualUrlData)
        }

        if (chatFiles) {
            recdownload = chatFiles.concat(recdownload)
        }
        dispatch(setChatRecordingFiles(recdownload))
    }

    handlePaidToggle = () => {
        dispatch(showApiLoader());
        dispatch(setStripeRequesting(true))
        let popUid = uuidv4()
        let user_id = this.props.userLoginData?.user?.id;
        createConnectLink(user_id, popUid)
            .then(async resp => {
                dispatch(hideApiLoader())
                if (resp.status == 1) {
                    let redir = resp.data?.data?.link;
                    if (redir) {
                        var win = window.open(redir);
                        this.stripeSession({
                            uid: popUid,
                            win
                        })
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                } else {
                    let msg = await dynamicMessageLocale(resp?.message);
                    toast(msg)
                }
            })
    }

    openCustomTour = () => {
        const { usersData } = this.props
        this.setState({
            isMenuOpen: false,
            takeTour: true,
        })
        dispatch(setCustomTourAction(true))
        dispatch(setTourGuideType(tourGuideActions.USER_STARTED_MANUALLY));
        dispatch(setTourGuideVisibility(usersData ? tourGuideVisibilityActions.TOUR_WITH_DEVICE : tourGuideVisibilityActions.TOUR_WITHOUT_DEVICE, '8'));
    }


    // menu items
    getItems() {
        const {
            isToolsOpen,
            isSubToolsOpen,
            isAudioToolsOpen,
            // user: { isLogged, isAdmin, isOpenRoom },
            isExploreOpen,
            isMixerShow,
            claimedRoomEvent,
            stripeActivated
        } = this.state;

        const allowedTools = getBaseConfig("tools");
        var siteName = getBaseConfig("sideBarTitle");
        if (getBaseConfig("menuLogoShow") == true) {
            let menuImg = getBaseConfig("menuImg");
            siteName = <><span className="brandlogo"><img src={menuImg} className="brand-logo-img" /></span></>
        } else {
            siteName = <><span className="brandlogo"
                dangerouslySetInnerHTML={{ __html: siteName }}>
            </span></>
        }

        const {
            usersData,
            menuStatus,
            showBox,
            isUserLogin,
            userLoginData,
            isModerator,
            dispatch,
            whiteboardAssets,
            roomorIpAddress,
            secondModerator,
            tokenDecodedData,
            conferenceJoined,
            t
        } = this.props;
        let willShowTools = true;
        // if (getBaseConfig("willAuthorize") == true) {	
        //     if (!tokenDecodedData?.teacher && !secondModerator) {	
        //         willShowTools = false;	
        //     }	
        // } 	
        if (!allowedTools.includes("tools")) {
            willShowTools = false
        }
        const isGuestAccount = getLJsonStorage("auth", "guest_id");
        let arrCommon = [
            !isGuestAccount && allowedTools.includes("dashboard") && (isUserLogin || (tokenDecodedData && (tokenDecodedData?.teacher || tokenDecodedData?.student))) &&
            <div
                id='dashboard'
                key="12"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        if (conferenceJoined) {
                            this.setState({ isConfirming: true, isMenuOpen: false })
                        } else {
                            this.handleRedirectToDashboard(true)
                        }
                    }
                }
            >
                <i className="fa fa-desktop" />
                <span>{t("rta-trmc.avatar.dashboard")}</span>
            </div>,

            this.props.conferenceJoined && allowedTools.includes("addParticipant") &&
            <div
                id='add-participants'
                key="8"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ explorePop: 'add-participants', isMenuOpen: false });
                    }
                }
            >
                <i className="fa fa-clipboard tool" />
                <span>{t("rta-trmc.tools.addParticipant")}</span>
            </div>,

            !isGuestAccount && this.props.conferenceJoined && allowedTools.includes("embedCode") &&
            <div
                id="embed-my-site"
                key="9"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ explorePop: 'embbeded-site', isMenuOpen: false });
                    }
                }
            >
                <i className="fa fa-ils tool" />
                <span>{t("rta-trmc.tools.embed")}</span>
            </div>,

            allowedTools.includes("login") &&
            <>
                {/* {isAdmin && */}
                {!isGuestAccount && this.props.conferenceJoined && userLoginData.isAdmin &&
                    <div
                        id='claim-room-setting'
                        key="10"
                        className="bm-item"
                        onClick={
                            (e) => {
                                e.preventDefault();
                                this.setState({
                                    explorePop: 'settings',
                                    isMenuOpen: false
                                });
                                sendAnalytics({
                                    action: 'room-settings',
                                    source: "toolbar",
                                    category: "room settings"
                                });
                            }
                        }
                    >
                        <i className="fa fa-wrench" />
                        <span>{t("rta-trmc.tools.claimRoomSetting")}</span>
                    </div>
                }
            </>,
            this.props.conferenceJoined && allowedTools.includes("claimRoom") &&
            <>
                {/* {isOpenRoom && */}
                {/* {userLoginData.isOpenRoom && 
                        // TEMP
                    */}
                {!isGuestAccount && !userLoginData.isRoomClaimed && !_ValidateIPaddress(roomorIpAddress) && !claimedRoomEvent &&
                    <div
                        key="7"
                        id='claim-this-room'
                        className="bm-item w-100"
                        onClick={
                            (e) => {
                                e.preventDefault();
                                if (userLoginData.isAdmin) {
                                    Toast(ct("messages.alreadyClaimed", "messages"), Constant.App.ToastTime.LongCloseTime);
                                    // } else if (!!isLogged) {
                                } else if (isUserLogin) {
                                    this.setState({ explorePop: 'claim-room', isMenuOpen: false });
                                    sendAnalytics({
                                        action: 'claim-room',
                                        source: "toolbar",
                                        category: "claim room"
                                    });
                                } else {
                                    dispatch(setIsClaimClicked(true));
                                    this.openLoginDialog(true, this.state);
                                    sendAnalytics({
                                        action: 'claim-room',
                                        source: "toolbar",
                                        category: "claim room"
                                    });
                                }
                            }
                        }
                    >
                        <i className="fa fa-sign-in tool" />
                        <span>{t("rta-trmc.tools.claimRoomSetting")}</span>
                    </div>
                }
            </>,
            <>
                {
                    !isGuestAccount && this.props.conferenceJoined && this.props.isUserLogin && getBaseConfig("paidLecture") == true && <>
                        {
                            stripeActivated && (userLoginData?.user?.connectVerified === connectAccountFlag.APPROVED || userLoginData?.user?.connectVerified === connectAccountFlag.ENABLED) ?
                                <div id='stripe-dashboard' key="14" className="bm-item w-100" onClick={this.handleStripeDashboard} >
                                    <i className="fa fa-dollar tool" />
                                    <span>{t("rta-trmc.avatar.stripe_dashboard")}</span>
                                </div>
                                :
                                (
                                    userLoginData?.user?.stripe_account_id && userLoginData?.user?.connectVerified != connectAccountFlag.FAILED
                                        ?
                                        <div className="bm-item w-100" style={{ cursor: "pointer" }}>
                                            <div className="dd-header" id='paid-room' onClick={() => {
                                                this.setState({
                                                    stripe_menu: !this.state.stripe_menu
                                                })
                                            }}>
                                                <i className="fa fa-dollar tool" /><span>{t("rta-trmc.tools.paidLecture")}</span>
                                                {
                                                    this.state.stripe_menu
                                                        ? <i className="fa fa-angle-up" aria-hidden="true"></i>
                                                        : <i className="fa fa-angle-down" aria-hidden="true"></i>
                                                }
                                            </div>
                                            {this.state.stripe_menu && <ul className="dd-list" id="stripe_menu" >
                                                <li id='stripe-dashboard' className="dd-list-item" key='stripe_dashboard'
                                                    onClick={this.handleStripeDashboard}
                                                >
                                                    <i className="fa fa-dollar tool mr-2" />
                                                    {t("rta-trmc.avatar.stripe_dashboard")}
                                                </li>
                                                <li id='stripe-update' className="dd-list-item w-100 d-flex" key='stripe_update'
                                                    onClick={() => this.handlePaidToggle()}
                                                >
                                                    <i className="fa fa-dollar tool mr-2" />{ct("stripeMessage.updateAdditionalConnectAccount", "stripeMessage")}
                                                </li>
                                            </ul>
                                            }

                                        </div>
                                        : <div key="14" id='set-up-paid-lecture' className="bm-item w-100" onClick={this.handleStripeAccount} >
                                            <i className="fa fa-dollar tool" />
                                            <span>{t("rta-trmc.tools.setUpPaidLecture")}</span>
                                        </div>

                                )
                        }
                    </>
                }
            </>,
            // <div key="2" style={{ cursor: "pointer" }} onClick={() => this.exploreTool()}>
            !isGuestAccount && this.props.conferenceJoined && allowedTools.includes("explore") && <div key="2" >
                <div id='my-room-menu' className="dd-header" style={{ cursor: "pointer" }} onClick={() => this.exploreTool()}>
                    <i className="fa fa-search-plus tool" /><span>{getBaseConfig("socialAllowed") ? t("rta-trmc.welcome.myRoom") : t("rta-trmc.tools.explore")}</span>
                    {isExploreOpen
                        ? <i className="fa fa-angle-up" aria-hidden="true"></i>
                        : <i className="fa fa-angle-down" aria-hidden="true"></i>
                    }
                </div>
                {
                    !isGuestAccount && isExploreOpen &&
                    <ul className="dd-list">
                        <li id='explore-other-room' className="dd-list-item" onClick={
                            (e) => {
                                e.preventDefault();
                                this.setState({
                                    explorePop: 'explore-room',
                                    isMenuOpen: false
                                });
                                sendAnalytics({
                                    action: 'explore-room',
                                    source: "toolbar",
                                    category: "explore room"
                                });
                            }
                        } key='Explore other room'>
                            <i className="fa fa-search mr-2" />
                            {t("rta-trmc.tools.exploreRoom")}
                        </li>
                        <li id='create-room' className="dd-list-item" onClick={
                            (e) => {
                                e.preventDefault();
                                this.setState({
                                    explorePop: 'create-room',
                                    isMenuOpen: false
                                });
                                sendAnalytics({
                                    action: 'create-room',
                                    source: "toolbar",
                                    category: "create room"
                                });
                            }
                        } key='create-room'>
                            <i className="fa fa-users mr-2" />
                            {ct("rta-trmc.tools.createNewRoom")}
                        </li>
                        {getBaseConfig("showRoomsListing") &&
                            <>
                                {/* My rooms */}
                                <li id='my-rooms-list' className='dd-list-item' key='my-rooms' onClick={(e) => {
                                    e.preventDefault();
                                    if (!this.state.myRoomList.length) {
                                        this.fetchMyRoomList();
                                    }
                                    this.setState({ isMyRoomList: !this.state.isMyRoomList, isExploreOpen: true })
                                }}>
                                    <i className='fa fa-user mr-2' />
                                    <>{ct("rta-trmc.welcome.myRoom")}</>
                                    {this.state.isMyRoomList
                                        ? <i className="fa fa-angle-up" aria-hidden="true"></i>
                                        : <i className="fa fa-angle-down" aria-hidden="true"></i>
                                    }
                                </li>
                                <ul>
                                    {this.state.isMyRoomList && !this.state.myRoomList.length && !this.state.myRoomListLoading ? <li id="my-room-empty">{t("rta-trmc.tools.noRoom")}</li> : null}
                                    {this.state.isMyRoomList && <>{this.state.myRoomList.map((room, index) => {
                                        if (index <= 4) {
                                            return <li id={`my-room-${index}`} className='dd-list-item' onClick={() => {
                                                this.setState({ isMyRoomList: true, isOtherRoomList: false });
                                                this.joinFromMyRooms(room?.groupName);
                                            }} key={index}><i className='fa fa-video-camera mr-2' />{room?.groupName}</li>
                                        } else if (index === 5) {
                                            return <li id={`my-room-${index}`} key={index} className='dd-list-item upload-media' onClick={() => {
                                                this.setState({ isViewMyRoomsModal: true, isMenuOpen: false, isMyRoomList: true, isOtherRoomList: false })
                                            }}>{ct("rta-trmc.tools.viewMore")}</li>
                                        }
                                    })}</>}
                                </ul>
                                {/* Other rooms */}
                                <li id='other-room-list' className='dd-list-item' key='other-rooms' onClick={(e) => {
                                    e.preventDefault();
                                    if (!this.state.otherRoomList.length) {
                                        this.fetchOtherRoomList();
                                    }
                                    this.setState({ isOtherRoomList: !this.state.isOtherRoomList, isExploreOpen: true })
                                }}>
                                    <i className='fa fa-user mr-2' />
                                    <>{t("rta-trmc.welcome.otherRoom")}</>
                                    {this.state.isOtherRoomList
                                        ? <i className="fa fa-angle-up" aria-hidden="true"></i>
                                        : <i className="fa fa-angle-down" aria-hidden="true"></i>
                                    }
                                </li>
                                <ul>
                                    {this.state.isOtherRoomList && !this.state.otherRoomList.length && !this.state.otherRoomListLoading ? <li>{t("rta-trmc.tools.noRoom")}</li> : null}
                                    {this.state.isOtherRoomList && <>{this.state.otherRoomList.map((room, index) => {
                                        if (index <= 4) {
                                            return <li id={`other-room-${index}`} className='dd-list-item' onClick={() => {
                                                this.setState({ isMyRoomList: false, isOtherRoomList: true });
                                                this.joinFromMyRooms(room?.groupName);
                                            }} key={index}><i className='fa fa-video-camera mr-2' />{room?.groupName}</li>
                                        } else if (index === 5) {
                                            return <li id={`other-room-${index}`} key={index} className='dd-list-item upload-media' onClick={() => {
                                                this.setState({ isViewMyRoomsModal: true, isMenuOpen: false, isOtherRoomList: true, isMyRoomList: false })
                                            }}>{ct("rta-trmc.tools.viewMore")}</li>
                                        }
                                    })}</>}
                                </ul>
                            </>
                        }
                    </ul>
                }
            </div>,
            this.props.conferenceJoined && allowedTools.includes("login") &&
            <>
                {/* {!!isLogged ? */}
                {!getBaseConfig("socialAllowed") &&
                    <>
                        {isUserLogin ?
                            <div id='sign-out' key="4" className="bm-item w-100" onClick={
                                (e) => { e.preventDefault(); this.logoutUser(true); }
                            }  ><i className="fa fa-sign-out tool" /><span>{t("rta-trmc.avatar.signOut")}</span></div> :
                            <div id='sign-in' key="6" className="bm-item w-100" onClick={
                                (e) => { e.preventDefault(); this.openLoginDialog(true); }
                            }  ><i className="fa fa-sign-in tool" /><span>{t("rta-trmc.avatar.signIn")}</span></div>
                        }
                    </>
                }
            </>,
            !isGuestAccount && this.props.conferenceJoined && allowedTools.includes("myRecordings") && (isUserLogin || (tokenDecodedData && (tokenDecodedData?.teacher || tokenDecodedData?.student))) &&
            <div
                key="12"
                className="bm-item"
                id='my-recordings'
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ openRecordingsModal: true, isMenuOpen: false, hitApi: true })
                        this.openMyRecordings();
                    }
                }
            >
                <i className="fa fa-video-camera" />
                <span>{t("rta-trmc.tools.myRecording")}</span>
            </div>,

            !isGuestAccount && this.props.conferenceJoined && allowedTools.includes("uploadWhiteboardMedia") && !_ValidateIPaddress(roomorIpAddress) &&
            <div
                id='upload-media'
                key="11"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ closeUploadMsgModals: true })
                        this.openUploadMediaDialog();
                        // {
                        //     isUserLogin ?
                        //         this.setState({ explorePop: 'upload', isMenuOpen: false })
                        //         :
                        //         this.openLoginDialog(true)
                        // }
                    }
                }
            >
                <i className="fa fa-upload" />
                <span>{t("rta-trmc.tools.uploadMedia")}</span>
            </div>,
            !isGuestAccount && this.props.conferenceJoined && willShowTools && <div key="5" id='tools-menu' style={{ cursor: "pointer" }} onClick={() => this.toggleTool()}>
                <div className="dd-header">
                    <i className="fa fa-cog tool" id='tools-menu-icon' /><span>{t("rta-trmc.tools.tool")}</span>
                    {isToolsOpen
                        ? <i className="fa fa-angle-up" aria-hidden="true"></i>
                        : <i className="fa fa-angle-down" aria-hidden="true"></i>
                    }
                </div>
                {
                    isToolsOpen &&
                    <ul className="dd-list">
                        {allowedTools.includes("guitarTuner") && <li id='chromatic-tuner' className="dd-list-item" onClick={
                            (e) => { e.preventDefault(); this.openTool('guitar-tuner'); }
                        } key='guitar-tuner'>
                            <div className="icon-img">
                                <img className="col-img1" src={guitartuner} />
                            </div>
                            {t("rta-trmc.tools.toolName.tuner")}
                        </li>}

                        {!showBox && allowedTools.includes("metronome") && <li id='metronome' className="dd-list-item" onClick={
                            (e) => { e.preventDefault(); this.openTool('metronome'); }
                        } key='metronome'>
                            <div className="icon-img">
                                <img className="col-img1" src={metronomeicon} />
                            </div>
                            {t("rta-trmc.tools.toolName.metronome")}
                        </li>}

                        {showBox && allowedTools.includes("latencyMetronome") &&
                            <li id='low-latency-metronome' className="dd-list-item" onClick={
                                (e) => { e.preventDefault(); this.openTool('box-metronome'); }
                            } key='box-metronome'>
                                <div className="icon-img">
                                    <img className="col-img1" src={metronomeicon} />
                                </div>
                                {t("rta-trmc.tools.toolName.lowLatencyMetronome")}
                            </li>
                        }

                        {allowedTools.includes("chordChart") && <li id='chord-chart-generator' className="dd-list-item" onClick={
                            (e) => { e.preventDefault(); this.openTool('voice-chord'); }
                        } key='voice-chord'>
                            <div className="icon-img">
                                <img className="col-img1" src={chordchart} />
                            </div>
                            {t("rta-trmc.tools.toolName.chordGenerator")}
                        </li>}

                        {allowedTools.includes("scaleGenerator") && <li id='guitar-scale-generator' className="dd-list-item" onClick={
                            (e) => { e.preventDefault(); this.openTool('guitar-scale'); }
                        } key='guitar-scale'>
                            <div className="icon-img">
                                <img className="col-img1" src={scalegenerator} />
                            </div>
                            {t("rta-trmc.tools.toolName.guitarGenerator")}
                        </li>}

                        {allowedTools.includes("piano") && <li id='piano' className="dd-list-item" onClick={
                            (e) => { e.preventDefault(); this.openTool('piano'); }
                        } key='piano'>
                            <div className="icon-img">
                                <img className="col-img1 _piano-icon" src={piano} />
                            </div>
                            {t("rta-trmc.tools.toolName.piano")}</li>}

                        {
                            allowedTools.includes("drum") &&
                            <li id='drum' className="dd-list-item" onClick={
                                (e) => { e.preventDefault(); this.openTool('drum'); }
                            } key='drum'>
                                <div className="icon-img">
                                    <img className="col-img1 _drum-icon" src={drum} />
                                </div>
                                {t("rta-trmc.tools.toolName.drum")}</li>}


                        {
                            allowedTools.includes("drum-set") &&
                            <li id='drum-set' className="dd-list-item" onClick={
                                (e) => { e.preventDefault(); this.openTool('drum-set'); }
                            } key='drum-set'>
                                <div className="icon-img">
                                    <img className="col-img1 _drum-icon" src={drumset} />
                                </div>
                                {t("rta-trmc.tools.toolName.drumSet")}</li>
                        }

                        {allowedTools.includes("whiteboard") && <li id='whiteboard' className="dd-list-item"
                            onClick={e => {
                                e.preventDefault();
                                this.openTool("white-board");
                            }} key="white-board">
                            <div className="icon-img" >
                                <img className="col-img1" src={whiteboard} />
                            </div>
                            {t("rta-trmc.tools.toolName.musicWhiteboard")}
                        </li>}
                        {!isGuestAccount && getBaseConfig("showShareAudio") == true && allowedTools.includes("uploadWhiteboardMedia") && this.state.whiteboardAudio && this?.props?.whiteboardAssets?.[0]?.total_count > 0 &&
                            <li>
                                {isToolsOpen && <div
                                    id='share-audio'
                                    key="7"
                                    style={{ cursor: "pointer" }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        this.toggleAudioTool();
                                    }}
                                >
                                    <div className="dd-header">
                                        <i className="fa fa-file-audio-o" />
                                        <span> {t("rta-trmc.tools.toolName.shareAudio")}</span>
                                        {isAudioToolsOpen ? (
                                            <i
                                                className="fa fa-angle-up"
                                                aria-hidden="true"
                                            ></i>
                                        ) : (
                                            <i
                                                className="fa fa-angle-down"
                                                aria-hidden="true"
                                            ></i>
                                        )}
                                    </div>
                                    {isAudioToolsOpen && (
                                        <ul className="dd-list-files">
                                            {/* <li
                                            className="dd-list-item"
                                            onClick={e => {
                                                e.preventDefault();
                                                this.openTool("audio1");
                                            }}
                                            key="audio1"
                                        >
                                            AUDIO-1
                                        </li> */}
                                            {/* <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("audio2");
                                                }}
                                                key="audio2"
                                            >
                                                AUDIO-2
                                            </li>
                                            <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("audio3");
                                                }}
                                                key="audio3"
                                            >
                                                AUDIO-3
                                            </li> */}
                                            {
                                                allowedTools.includes("uploadWhiteboardMedia") && <>{this.getAudio()}</>
                                            }
                                        </ul>
                                    )}
                                </div>

                                }

                            </li>
                        }
                        {this.props.whiteboardAssets?.length > 0 && !isGuestAccount && getBaseConfig("showShareFiles") == true && this.state.whiteboardFiles && allowedTools.includes("uploadWhiteboardMedia") && this?.props?.whiteboardAssets?.[1]?.total_count > 0 &&
                            <li>
                                {isToolsOpen && <div
                                    id='share-files'
                                    key="6"
                                    style={{ cursor: "pointer" }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        this.toggleSubTool();
                                    }}
                                >
                                    <div className="dd-header">
                                        <i className="fa fa-file-pdf-o" />
                                        <span> {t("rta-trmc.tools.toolName.shareFiles")}</span>
                                        {isSubToolsOpen ? (
                                            <i
                                                className="fa fa-angle-up"
                                                aria-hidden="true"
                                            ></i>
                                        ) : (
                                            <i
                                                className="fa fa-angle-down"
                                                aria-hidden="true"
                                            ></i>
                                        )}
                                    </div>
                                    {isSubToolsOpen && (
                                        <ul className="dd-list-files">
                                            {/* <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("sample1");
                                                }}
                                                key="sample1"
                                            >
                                                PDF-1
                                            </li>
                                            <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("sample2");
                                                }}
                                                key="sample2"
                                            >
                                                PDF-2
                                            </li>
                                            <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("sample3");
                                                }}
                                                key="sample3"
                                            >
                                                PDF-3
                                            </li>
                                            <li
                                                className="dd-list-item"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.openTool("whiteboard_waltz_minor");
                                                }}
                                                key="whiteboard_waltz_minor"
                                            >
                                                Waltz in A Minor
                                            </li> */}
                                            {
                                                allowedTools.includes("uploadWhiteboardMedia") && <>{this.getFiles()}</>
                                            }
                                        </ul>
                                    )}
                                </div>

                                }

                            </li>
                        }
                    </ul>
                }
            </div>,

            !isGuestAccount && this.props.conferenceJoined && getBaseConfig('customTutorial') &&
            <div
                id='guide-tour'
                key="16"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.openCustomTour();
                    }
                }
            >
                <i className="fa fa-info-circle" />
                <span> {t("rta-trmc.tools.toolName.guidedTour")}</span>
            </div>,

            !this.props.conferenceJoined && getBaseConfig("deviceHelp") == true &&
            <div
                id="troubleshooting-rta-device"
                className="bm-item"
                key="17"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ isMenuOpen: false });
                        dispatch(setShowDeviceHelpingGuide(true))
                    }
                }>
                <i className='fa fa-lightbulb-o' />
                <span> {t("rta-trmc.avatar.troubleShot")}</span>
            </div>,

            !this.props.conferenceJoined && getBaseConfig("deviceHelp") == true &&
            <div
                id="settings-icon"
                className="bm-item"
                key="18"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ isMenuOpen: false });
                        dispatch(setAvatarPop(false));
                        dispatch(openSettingsDialog(SETTINGS_TABS.CALENDAR))
                    }
                }>
                <i className='fa fa-cog' />
                <span>{t("rta-trmc.avatar.setting")}</span>
            </div>,

            !isGuestAccount && !isSocialMobileApp() && getBaseConfig('socialAllowed') &&
            <div
                id='rta-social-network'
                key="17"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ isRedirectToRTASocialWeb: true, isMenuOpen: false });
                    }
                }
            >
                <img src={getBaseConfig("socialWebIcon")} height="14px" />
                <span>{t("rta-trmc.avatar.rtaSocial")}</span>
            </div>,
            this.props.conferenceJoined && getBaseConfig("showSignOutButton") && <div
                id='rta-sign-out'
                key="18"
                className="bm-item"
                onClick={
                    (e) => {
                        e.preventDefault();
                        this.setState({ isMenuOpen: false });
                        dispatch(setLogoutType(true));
                    }
                }
            >
                <i className="fa fa-sign-out tool" />
                <span>{t("rta-trmc.avatar.logout")}</span>
            </div>,
        ];
        let signedUsername = getLJsonStorage("auth", "username") || userLoginData?.user?.username;
        if (signedUsername) {
            signedUsername = signedUsername.charAt(0).toUpperCase() + signedUsername.slice(1);
        }
        let arr2 = [
            this.props.conferenceJoined && <div key="1">
                {/* <h2 ><span className="brandlogo"> RealTime Audio <span></span></span></h2> */}
                <h2 className="brandlogo_container">
                    {siteName}
                    {userLoginData?.user && getBaseConfig("socialAllowed") && <p className='signed-username'>{t("rta-trmc.avatar.signInAs")}: {signedUsername} </p>}
                </h2>
            </div>,

            // <div key="2" className="bm-item" onClick={() => this.setState({ explorePop: 'webjam-mixer', isMenuOpen: false })}>
            this.props.conferenceJoined && allowedTools.includes("mixer") && <div key="2" id="mixer" className="bm-item" onClick={() => this.setState({ explorePop: 'webjam-mixer', isMenuOpen: false })}>
                <i className="fa fa-gear" /><span>{t("rta-trmc.tools.toolName.mixer")} </span>
            </div>,

            // <div key="3" className="bm-item" onClick={() => this.unpairWebjam()}>
            this.props.conferenceJoined && allowedTools.includes("mixer") && <div key="3" id="disconnect-rta-device" className="bm-item" onClick={() => this.handleUnpairDevice()}>
                <i className="fa fa-music" /><span>{getBaseConfig("boxUnPairTitle")}</span>
            </div>,
        ]

        let arr1 = [
            <div key="1">
                {/* <h2 ><span className="brandlogo"> RealTime Audio <span></span></span></h2> */}
                <h2 className="brandlogo_container" >
                    {siteName}
                    {userLoginData?.user && getBaseConfig("socialAllowed") && <p className='signed-username'>{t("rta-trmc.avatar.signInAs")}: {signedUsername} </p>}
                </h2>
            </div>,

            // <div key="2" className="bm-item" onClick={() => this.setState({ explorePop: 'webjam', isMenuOpen: false })}>
            this.props.conferenceJoined && allowedTools.includes("mixer") && <div key="2" id="realTimeAudioDevice" className="bm-item" onClick={() => this.handlePairDevice()}>
                <i className="fa fa-music" /><span>{getBaseConfig("boxPairTitle")}</span>
            </div>,
        ]

        let arrFinal = [];
        if (menuStatus) {
            arrFinal = usersData ? arr2 : arr1;
        } else {
            let arr0 = [
                this.props.conferenceJoined && <div key="1">
                    <h2 ><span className="brandlogo">Taylor Robinson <span>Music Live</span></span></h2>
                </div>,
            ]
            arrFinal = arr0;
        }

        arrFinal.push(arrCommon);
        return arrFinal;
    }

    onOpenMenu(e) {
        this.setState({
            isMenuOpen: true,
            isToolsOpen: false,
            isExploreOpen: false,
            isSubToolsOpen: false,
            isAudioToolsOpen: false,
            showSidebarCustomTooltip: false
        })
        setTimeout(() => {
            VideoLayout.resizeVideoArea();
        }, 10);
    }

    onCloseMenu(e) {
        this.setState({
            isMenuOpen: false,
            isToolsOpen: false,
            isExploreOpen: false,
            isSubToolsOpen: false,
            isAudioToolsOpen: false,
        })
        let _this = this;
        setTimeout(() => {
            _this.setState({
                showSidebarCustomTooltip: true
            })
        }, 1000)
        this.props.dispatch(setIsPollsTabFocused(false));
        this.props.dispatch(setChatTranslatorStatus(false));
    }

    socialWebLink(e) {
        this.setState({ isRedirectToRTASocialWeb: false });
        window.parent.location.href = Constant.App.socialUrl;
    }

    // wraping the menu items
    getMenu(_getBaseConfig: fn) {
        const { isMenuOpen, currentMenu, side, showSidebarCustomTooltip } = this.state;

        // setting burger menu
        const Menu = BurgerMenu[currentMenu];
        const { conferenceJoined, isShowPaymentDashboard } = this.props;
        let socialLinkImage = getBaseConfig("socialWebLogo");
        let showHomePageHomeIcon = getBaseConfig("showHomePageHomeIcon");
        let sidebarProfileIcon = getBaseConfig("sidebarProfileIcon");
        let homeIconPathImage = getBaseConfig("homeIconPathImage");
        let showHomeIcon = false;
        let homeIconPath = <img className='sidebar-profile-menu-button' src={homeIconPathImage} />
        let userImage = getLJsonStorage("auth", "image_url") ? getLJsonStorage("auth", "image_url") : dummyPlaceholder;
        const overlaySidebarMenuButton = getBaseConfig("overlaySidebarMenuButton");

        if (conferenceJoined || (showHomePageHomeIcon && !CURRENT_ROOM_NAME)) {
            showHomeIcon = true;
        }

        if (isShowPaymentDashboard) {
            showHomeIcon = false;
        }

        if (showHomePageHomeIcon && !CURRENT_ROOM_NAME) {
            homeIconPath = <img className='sidebar-profile-menu-button' src="/images/logo/hamburger-settings-white.png" />
        }

        if (sidebarProfileIcon && CURRENT_ROOM_NAME) {
            homeIconPath = <img
                className='sidebar-profile-menu-button'
                id='user-avatar-img'
                onError={(e) => {
                    e.target.src = dummyPlaceholder;
                }}
                src={userImage} />
        }
        let menuClass = '';
        if (homeIconPathImage == '' && !getBaseConfig("socialAllowed")) {
            homeIconPath = <NavBars />
            menuClass = "custom-bm-menu-wrap"
        }

        let customTooltipClass = "custom-tooltip-hamburger"
        if (!showSidebarCustomTooltip) {
            customTooltipClass = "custom-tooltip-hamburger-hide"
        }
        const isMobile = isMobileBrowserC();
        return (
            <>
                <CustomTooltip className={customTooltipClass} content={ct("Translate.tooltipContent.menuTooltip")} position="top">
                    <MenuWrap wait={20} side={side} willNotShow={showHomeIcon}>
                        <>
                            <Menu
                                isOpen={!!isMenuOpen}
                                onStateChange={(state) => this.handleStateChange(state)}
                                className={isMenuOpen ? "open-bottom-menu" : ""}
                                id={currentMenu}
                                pageWrapId={'page-wrap'}
                                outerContainerId={'outer-container'}
                                right={side === 'right'}
                                onOpen={(e) => isMenuOpen ? this.onCloseMenu(e) : this.onOpenMenu(e)}
                                onClose={(e) => this.onCloseMenu(e)}
                                customBurgerIcon={homeIconPath}
                                burgerButtonClassName={`${menuClass} ${overlaySidebarMenuButton && !isMobile ? "overlay-sidebar-menu-button" : ""} ${isMenuOpen ? "open-sidebar-menu-button" : ""}`}
                            >
                                {this.getItems()}
                            </Menu>
                            {/* {getBaseConfig("socialAllowed") &&
                            <Tooltip
                                title="Click to go on RTA Social Web"
                                placement="right"
                                arrow
                                id="social-web-link-tooltip"
                                >
                                <div className='social-web-link-container'>
                                <img src={socialLinkImage} className='social-web-link-logo' onClick={(e) => this.socialWebLink(e)} />
                                </div>
                                </Tooltip>
                                
                            } */}
                        </>
                    </MenuWrap>
                </CustomTooltip>
            </>
        );
    }

    handleSocketEvent() {

    }

    handleRedirectToDashboard(type) {
        let { userLoginData } = this.props;
        this.setState({ isConfirming: false });
        if (type) {
            // social url change code
            let socialAllowed = getBaseConfig("socialAllowed");
            if (socialAllowed == true) {
                if (isSocialMobileApp()) {
                    window.location.href = getBaseConfig('appReferrerUrl') + "?socialPath=dashboard";
                } else {
                    window.parent.location.href = getBaseConfig("socialBaseUrl") + "/rooms";
                    sessionStorage.setItem('showDashboard', true);
                }
            } else {
                sessionStorage.setItem('showDashboard', true);
                window.location.href = window.location.origin
            }
        }
    }

    handleState = (obj) => {
        this.setState({ ...obj })
    }


    render() {

        const {
            openTool,
            isJamDailogOpen,
            isLoginDialogOpen,
            explorePop,
            user,
            mediaDetail,
            isManualOpen,
            toolOpenLocal,
            toolDetail,
            takeTour,
            showHangupPopup
        } = this.state;

        const {
            usersData,
            roomorIpAddress,
            metronomeStatus,
            userLoginData,
            _iAmRecorder,
            isUserLogin,
            isClaimClicked,
            dispatch,
            showUploadModal,
            chatFiles,
            outAutoManage,
            customTourAction,
            conferenceJoined,
            autoManageHostTrigger,
            showRtaJamInvitePopup,
            tourGuideVisibility,
            t,
            downloadTitle
        } = this.props;

        let localWindowRedirect = localStorage.getItem("windowRedirect")

        if (isClaimClicked && isUserLogin) {
            dispatch(setIsClaimClicked(false));
            this.setState({ explorePop: 'claim-room', isMenuOpen: false })
        }

        if (showUploadModal && userLoginData.isAdmin) {
            dispatch(setshowUploadModal(false));
            this.setState({ explorePop: 'upload', isMenuOpen: false })
        }


        return (
            <div id="outer-container"
                style={{ height: '100%' }}
            >
                {
                    this.props.confirmationModalProps?.isShow && this.props.confirmationModalProps?.type !== 'dashboard' && <GenericConfirmationModal onCancel={() => dispatch(setConfirmationModalProps({ isShow: false }))} {...this.props.confirmationModalProps} />
                }
                {this.props.showTutorial && <Tutorial onClose={() => {
                    dispatch(setDeviceContainerStatus("open", 'afterTutorialClose'))
                    dispatch(showTutorialModal(false));
                }} />}
                {this.props.isShowMixerSettings && this.props.usersData && <MixerSettings />}
                {
                    this.props.isLogout && <GenericConfirmationModal className="logout-confirmation-modal" title={t('dialog.logoutTitle')} content={ct("Translate.messages.logoutText")} onSuccess={() => handleUserLogout(this.props)} onCancel={() => dispatch(setLogoutType(false))} />
                }
                {this.state.isRedirectToRTASocialWeb
                    && <GenericConfirmationModal
                        className="homepage-redirect-social-modal"
                        title={ct("rta-trmc.dashboard.sideBarMenu.RTA_SOCIAL_NETWORK")}
                        content={ct("Translate.confirmMessages.socialRedirect")}
                        onSuccess={() => this.socialWebLink()}
                        onCancel={() => this.setState({ isRedirectToRTASocialWeb: false })}
                    />}
                {showRtaJamInvitePopup && <AddRtaJamPeopleDialog />}
                {this.state.isConfirming
                    && <GenericConfirmationModal
                        className="homepage-redirect-dashboard"
                        title={ct("rta-trmc.avatar.dashboard")}
                        content={ct("rta-trmc.confirmationDialog.leaveRoom")}
                        onSuccess={() => this.handleRedirectToDashboard(true)}
                        onCancel={() => this.setState({ isConfirming: false })}
                    />}
                {this.state.isViewMyRoomsModal && <MyRoomsModal title={this.state.isMyRoomList ? ct("rta-trmc.welcome.myRoom") : ct("rta-trmc.welcome.otherRoom")} myRoomList={this.state.isMyRoomList ? this.state.myRoomList : this.state.otherRoomList} joinFromMyRooms={this.joinFromMyRooms} handleState={this.handleState} />}
                {this.state.isJoiningAnotherRoom && <JoinRoomConfirmation title={this.state.isMyRoomList ? ct("rta-trmc.welcome.myRoom") : ct("rta-trmc.welcome.otherRoom")} roomName={this.state.roomName} handleState={this.handleState} />}
                {this.mediaModal()}
                {this.openMyRecordings()}
                {this.toSignInMsgModal()}
                {this.toClaimMsgModal()}
                {this.getMenu()}
                <main id="page-wrap">
                    {this.props.children}
                    <Tools
                        iAmRecorder={_iAmRecorder}
                        metronomeStatus={metronomeStatus}
                        roomorIpAddress={roomorIpAddress}
                        usersData={usersData}
                        activeTool={openTool}
                        socket={socket}
                        mediaDetail={mediaDetail}
                        isManualOpen={isManualOpen}
                        closeTool={() => this.closeTool()}
                        toolOpenLocal={toolOpenLocal}
                        Sessions={{ SessionId, openByUser }}
                        toolDetail={toolDetail}
                        openToolStatus={this.openToolStatus}
                    />

                </main>
                <Jamulus isOpen={!!isJamDailogOpen} closeJam={() => this.jamulusDailog(false)} />
                <Login isOpen={!!isLoginDialogOpen}
                    closeLogin={(res, type, signupClose) => this.closeLoginDialog(res, type, signupClose)}
                    setCurrentUser={(user) => {
                        return this.setUser(user)
                    }}
                    _iAmRecorder={_iAmRecorder}
                />
                <Explore
                    key={explorePop}
                    // user={user}
                    user={userLoginData}
                    explorePop={explorePop}
                    openLogin={(res) => this.openLoginDialog(res)}
                    changePopupState={(resp) => this.setState({ explorePop: resp })}
                    stripeSession={(res) => this.stripeSession(res)}
                />

                <Downloader
                    title={downloadTitle || ct("rta-trmc.dashboard.myRecording.downloadRecordings")}
                    files={chatFiles}
                />
                {
                    takeTour &&
                    customTourAction &&
                    conferenceJoined == true &&
                    localWindowRedirect == null &&
                    tourGuideVisibility != tourGuideVisibilityActions.TOUR_EMPTY &&
                    <CustomTour />
                }
                {/* {usersData?.users?.length > 0 && autoManageHostTrigger &&  */}
                <ManageHost />
                <SocketListnerInitApi
                    handleSocketEvent={this.handleSocketEvent}
                />
                {
                    showHangupPopup &&
                    <HostHangup />
                }
            </div>
        );
    }
}



function _mapStateToProps(state) {
    let moderatorArray = [];
    const isModerator = isLocalParticipantModerator(state);
    const remoteParticipants = getRemoteParticipants(state);
    const remoteArray = _.flatten(Array.from(remoteParticipants));

    if (remoteArray?.length > 0) {
        _.filter(remoteArray, function (item) {
            if (item.role === "moderator") {
                moderatorArray.push(item);
            }

            return moderatorArray;
        });
    }

    return {
        room: state[FEATURE_CUSTOM_REDUX].room,
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        menuStatus: state[FEATURE_CUSTOM_REDUX].menuStatus,
        deviceList: state[FEATURE_CUSTOM_REDUX].deviceList,
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        protocolId: state[FEATURE_CUSTOM_REDUX].protocolId,
        connected: state[FEATURE_CUSTOM_REDUX].connected,
        publicIp: state[FEATURE_CUSTOM_REDUX].publicIp,
        ghostList: state[FEATURE_CUSTOM_REDUX].ghostList,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        metronomeStatus: state[FEATURE_CUSTOM_REDUX].metronomeStatus,
        showBox: state[FEATURE_CUSTOM_REDUX].showBox,
        clickMakeHost: state[FEATURE_CUSTOM_REDUX].clickMakeHost,
        getLocalParticipant: getLocalParticipant(state),
        customJoinMeeting: state["features/prejoin"].customJoinMeeting,
        userDisabledPreJoin: state["features/base/settings"].userSelectedSkipPrejoin,
        audioGhost: state[FEATURE_CUSTOM_REDUX].audioGhost,
        isUserLogin: state[FEATURE_CUSTOM_REDUX].isUserLogin,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        roomPassProtectModal: state[FEATURE_CUSTOM_REDUX].roomPassProtectModal,
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        isModerator: isModerator,
        moderatorCount: moderatorArray.length,
        isClaimClicked: state[FEATURE_CUSTOM_REDUX].isClaimClicked,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        whiteboardAssets: state[FEATURE_CUSTOM_REDUX_V2].whiteboardAssets,
        isDeviceListed: state[FEATURE_CUSTOM_REDUX_V2].isDeviceListed,
        secondModerator: state[FEATURE_CUSTOM_REDUX].secondModerator,
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        isChatOpened: state['features/chat'].isOpen,
        deviceContainerStatus: state[FEATURE_CUSTOM_REDUX_V2].deviceContainerStatus,
        showUploadModal: state[FEATURE_CUSTOM_REDUX_V2].showUploadModal,
        paidRoomDetail: state[FEATURE_CUSTOM_REDUX_V2].paidRoomDetail,
        toolsObject: state[FEATURE_CUSTOM_REDUX_V2].toolsObject,
        isMyRecordingsModal: state[FEATURE_CUSTOM_REDUX_V2].isMyRecordingsModal,
        myRecordingsData: state[FEATURE_CUSTOM_REDUX_V2].myRecordingsData,
        chatFiles: state[FEATURE_CUSTOM_REDUX].chatFiles,
        toolModal: state[FEATURE_CUSTOM_REDUX_V2].toolModal,
        uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
        thirdPartyClicked: state[FEATURE_CUSTOM_REDUX_V2].thirdPartyClicked,
        _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
        isAutoMakeHostChecked: state[FEATURE_CUSTOM_REDUX_V2].isAutoMakeHostChecked,
        prejoinScreenDetail: state[FEATURE_CUSTOM_REDUX_V2].prejoinScreenDetail,
        clickedAutoMakeHost: state[FEATURE_CUSTOM_REDUX].clickedAutoMakeHost,
        outAutoManage: state[FEATURE_CUSTOM_REDUX_V2].outAutoManage,
        availableUserIp: state[FEATURE_CUSTOM_REDUX_V2].availableUserIp,
        customTourAction: state[FEATURE_CUSTOM_REDUX_V2].customTourAction,
        autoManageHostTrigger: state[FEATURE_CUSTOM_REDUX_V3].autoManageHostTrigger,
        showRtaJamInvitePopup: state[FEATURE_CUSTOM_REDUX_V3].showRtaJamInvitePopup,
        localAutoConnect: state[FEATURE_CUSTOM_REDUX_V3].localAutoConnect,
        hostTabData: state[FEATURE_CUSTOM_REDUX].hostTabData,
        isParticipantThirdPartyListen: state[FEATURE_CUSTOM_REDUX_V3].isParticipantThirdPartyListen,
        isModeratorThirdPartyListen: state[FEATURE_CUSTOM_REDUX_V3].isModeratorThirdPartyListen,
        isDeviceConnecting: state[FEATURE_CUSTOM_REDUX_V3].isDeviceConnecting,
        hostEventReceived: state[FEATURE_CUSTOM_REDUX_V3].hostEventReceived,
        participantCount: getParticipantCount(state),
        hostHangupAutoConnect: state[FEATURE_CUSTOM_REDUX_V3].hostHangupAutoConnect,
        windowRef: state[FEATURE_CUSTOM_PAYMENT].windowRef,
        lobbyStatus: state[FEATURE_CUSTOM_REDUX].lobbyStatus,
        tourGuideType: state[FEATURE_CUSTOM_REDUX_V3].tourGuideType,
        tourGuideVisibility: state[FEATURE_CUSTOM_REDUX_V3].tourGuideVisibility,
        invitedUserConfirm: state[FEATURE_CUSTOM_REDUX_V3].invitedUserConfirm,
        isShowPaymentDashboard: state[FEATURE_CUSTOM_PAYMENT].isShowPaymentDashboard,
        isLogout: state[FEATURE_CUSTOM_REDUX].isLogout,
        isShowMixerSettings: state[FEATURE_CUSTOM_REDUX_V2].isShowMixerSettings,
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        showTutorial: state[FEATURE_CUSTOM_REDUX_V3].showTutorial,
        confirmationModalProps: state[FEATURE_CUSTOM_REDUX_V3].confirmationModalProps,
        serverConnectRehit: state[FEATURE_CUSTOM_REDUX_V3].serverConnectRehit,
        boxDeviceErrorInfo: state[FEATURE_CUSTOM_REDUX_V3].boxDeviceErrorInfo,
        downloadTitle: state[FEATURE_CUSTOM_REDUX_V3].downloadTitle,
        showDevicePreConnection: state[FEATURE_CUSTOM_REDUX_V3].showDevicePreConnection,
        isNatType: state[FEATURE_CUSTOM_REDUX_V3].isNatType,
        hostHangupEventReceived: state[FEATURE_CUSTOM_REDUX_V3].hostHangupEventReceived,
        isDisconnectListened: state[FEATURE_CUSTOM_REDUX_V3].isDisconnectListened,
        socialSettingDialogStatus: state[FEATURE_CUSTOM_REDUX_V3].socialSettingDialogStatus,
        recordingDetails: state[FEATURE_CUSTOM_REDUX_V3].recordingDetails,
        stemRecordingUrl: state[FEATURE_CUSTOM_REDUX].stemRecordingUrl,
        stemRecording: state[FEATURE_CUSTOM_REDUX].stemRecording,
        hitFirewallApi: state[FEATURE_CUSTOM_REDUX_V3].hitFirewallApi,
    };
}

export default translate(connect(_mapStateToProps)(Layout));
